<template>
  <v-content>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-card class="elevation-2" color="#B2DFDB">
        <v-card-title>
          <span>จัดการข้อมูลบุคคล</span>
        </v-card-title>
        <v-card-text>
          <v-list-item v-if="CheckApprove">
            <v-card width="100%" class="mb-16" color="#B2DFDB" style="border: white 2px solid">
              <v-subheader>
                <span class="font-weight-bold">Export ข้อมูลสำหรับ HR</span>
              </v-subheader>
              <v-card-text>
                <v-row class="d-flex justify-center">
                  <v-col
                      cols="12"
                      md="3"
                      v-if="Choice != '3' && Choice != '4'"
                  >
                    <v-text-field type="date" label="วันที่เริ่มต้น" v-model="dateExStart"></v-text-field>
                  </v-col>
                  <v-col
                      cols="12"
                      md="3"
                      v-if="Choice != '3' && Choice != '4'"
                  >
                    <v-text-field type="date" label="วันที่สิ้นสุด" v-model="dateExEnd"></v-text-field>
                  </v-col>
                  <v-col
                      cols="12"
                      md="3">
                    <v-select
                        v-model="Choice"
                        :items="ChoiceExport"
                        item-text="text"
                        item-value="value"
                        label="เลือกข้อมูลที่ต้องการ Export"
                    ></v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      md="3"
                      class="d-flex justify-center"
                  >
                    <v-btn color="pink" dark class="lighten-2" @click="ExportAllData" v-if="!exportExec"
                           :loading="btnLoading">
                      Export ข้อมูล
                    </v-btn>
                    <download-excel
                        class="btn btn-default"
                        :data="json_Export"
                        :fields="json_fields_all"
                        worksheet="ประวัติการฝึกอบรม"
                        :name="'รายงานสรุปประวัติการฝึกอบรม.xls'"
                        v-else-if="exportExec && Choice == '0'"
                    >
                      <v-btn color="green" dark class="lighten-2" @click="exportExec = false">
                        Download ไฟล์ Excel
                      </v-btn>
                    </download-excel>
                    <download-excel
                        class="btn btn-default"
                        :data="json_Export"
                        :fields="json_fields_all"
                        worksheet="ประวัติกรรมการ"
                        :name="'รายงานสรุปประวัติกรรมการ.xls'"
                        v-else-if="exportExec && Choice == '1'"
                    >
                      <v-btn color="green" dark class="lighten-2" @click="exportExec = false">
                        Download ไฟล์ Excel
                      </v-btn>
                    </download-excel>
                    <download-excel
                        class="btn btn-default"
                        :data="json_Export"
                        :fields="json_fields_all"
                        worksheet="ประวัติวิทยากร/อ.พิเศษ/ผลงาน"
                        :name="'รายงานสรุปประวัติวิทยากร/อ.พิเศษ/นำเสนอผลงาน.xls'"
                        v-else-if="exportExec && Choice == '2'"
                    >
                      <v-btn color="green" dark class="lighten-2" @click="exportExec = false">
                        Download ไฟล์ Excel
                      </v-btn>
                    </download-excel>
                    <download-excel
                        class="btn btn-default"
                        :data="json_Export"
                        :fields="json_Journal_all"
                        worksheet="บทความ"
                        :name="'รายงานสรุปบทความ.xls'"
                        v-else-if="exportExec && Choice == '3'"
                    >
                      <v-btn color="green" dark class="lighten-2" @click="exportExec = false">
                        Download ไฟล์ Excel
                      </v-btn>
                    </download-excel>
                    <download-excel
                        class="btn btn-default"
                        :data="json_Export"
                        :fields="json_Extra_all"
                        worksheet="ประวัติรางวัลพิเศษ"
                        :name="'รายงานสรุปประวัติรางวัลพิเศษ.xls'"
                        v-else
                    >
                      <v-btn color="green" dark class="lighten-2" @click="exportExec = false">
                        Download ไฟล์ Excel
                      </v-btn>
                    </download-excel>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-list-item>
          <v-list-item>
            <v-autocomplete outlined
                            label="เลือกหน่วยงาน"
                            :items="DepartData"
                            item-text="dep_name"
                            item-value="dep_id"
                            v-model="dep_sel"
                            @change="SelDepFunc(true)"
            ></v-autocomplete>
          </v-list-item>
          <v-list-item>
            <v-autocomplete outlined
                            label="เลือกบุคลากร"
                            :items="dumpStaff"
                            item-text="customDetail"
                            item-value="perid"
                            v-model="staff_sel_choose"
                            @change="SelStaffFunc"
                            @click:clear="CheckStaffSelClear"
                            clearable
            ></v-autocomplete>
          </v-list-item>
          <v-row justify="center">
            <v-expansion-panels popout>
              <v-expansion-panel
                  v-for="(staff_i,i) in StaffDataForDep"
                  :key="i"
                  @click="GetDataProfile(staff_i)"
                  readonly
              >
                <v-expansion-panel-header>
                  <v-row
                      align="center"
                      class="spacer"
                      no-gutters
                  >
                    <v-col
                        cols="6"
                        sm="4"
                        md="2"
                    >
                      <v-avatar
                          size="120px"
                      >
                        <!--                      <img-->
                        <!--                          :src="'https://medhr.medicine.psu.ac.th/ImageMED.php?pid=' + staff_i.perid"-->
                        <!--                          :alt="staff_i.full_Name"-->
                        <!--                      >-->
                        <v-img
                            :src="'https://medhr.medicine.psu.ac.th/ImageMED.php?pid=' + staff_i.perid"
                            :alt="staff_i.full_Name"
                            lazy-src="https://picsum.photos/id/11/100/60"
                            max-width="500"
                            max-height="300"
                        >
                          <template v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                              <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>
                    </v-col>

                    <v-col
                        cols="6"
                        sm="8"
                        md="10"
                    >
                      <strong style="font-weight: bold;font-size: 25px">{{ staff_i.perid }}
                        {{ staff_i.full_Name }}</strong>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  {{ staff_i.full_name }}
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-card-text>
      </v-card>
      <v-dialog
          v-model="dialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
          scrollable
      >
        <v-card tile>
          <!--        <v-toolbar-->
          <!--            flat-->
          <!--            dark-->
          <!--            color="primary"-->
          <!--        >-->
          <!--          <v-btn-->
          <!--              icon-->
          <!--              dark-->
          <!--              @click="dialog = false"-->
          <!--          >-->
          <!--            <v-icon>mdi-close</v-icon>-->
          <!--          </v-btn>-->
          <!--          <v-avatar-->
          <!--              size="120px"-->
          <!--          >-->
          <!--            <img-->
          <!--                :src="'https://mednet.psu.ac.th/Personal/ShowPictNew.php?pid=' + staff_sel.perid"-->
          <!--                :alt="staff_sel.full_Name"-->
          <!--            >-->
          <!--          </v-avatar>-->
          <!--          <v-toolbar-title v-if="staff_sel != null">{{ staff_sel.full_Name }}</v-toolbar-title>-->
          <!--          <v-spacer></v-spacer>-->
          <!--          <v-toolbar-items>-->
          <!--            <v-btn-->
          <!--                dark-->
          <!--                text-->
          <!--                @click="dialog = false"-->
          <!--            >-->
          <!--              Save-->
          <!--            </v-btn>-->
          <!--          </v-toolbar-items>-->
          <!--        </v-toolbar>-->
          <v-app-bar
              absolute
              color="#6A76AB"
              dark
              shrink-on-scroll
              prominent
              src="https://picsum.photos/1920/1080?random"
              fade-img-on-scroll
              scroll-target="#scrolling-techniques-3"
          >
            <template v-slot:img="{ props }">
              <v-img
                  v-bind="props"
                  gradient="to top right, rgba(100,115,201,.7), rgba(25,32,72,.7)"
              ></v-img>
            </template>

            <v-btn
                icon
                dark
                @click="dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <span v-if="staff_sel != null">{{ staff_sel.full_Name }} ({{ staff_sel.perid }})</span>

            <v-spacer></v-spacer>

            <v-avatar
                size="100px"
                v-if="staff_sel != null"
                style="border: 5px solid antiquewhite"
            >
              <img
                  :src="'https://medhr.medicine.psu.ac.th/ImageMED.php?pid=' + staff_sel.perid"
                  :alt="staff_sel.full_Name"
              >
            </v-avatar>

            <template v-slot:extension>
              <v-tabs align-with-title v-model="tab">
                <v-tab href="#tab-1" style="font-size: 16px">ข้อมูลส่วนตัว</v-tab>
                <v-tab href="#tab-2" style="font-size: 16px">ฝึกอบรม</v-tab>
                <v-tab href="#tab-3" style="font-size: 16px">คณะกรรมการ</v-tab>
                <v-tab href="#tab-4" style="font-size: 16px">วิทยากร / อาจารย์พิเศษ / นำเสนอผลงาน</v-tab>
                <v-tab href="#tab-5" style="font-size: 16px">บทความ</v-tab>
                <v-tab href="#tab-6" style="font-size: 16px">รางวัลพิเศษ</v-tab>
                <v-tab href="#tab-7" style="font-size: 16px">สมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์</v-tab>
                <v-tab></v-tab>
              </v-tabs>
            </template>
          </v-app-bar>
          <v-sheet
              id="scrolling-techniques-3"
              class="overflow-y-auto"
          >
            <v-container style="height: 250px;"></v-container>
            <v-tabs-items v-model="tab">
              <v-tab-item
                  value="tab-1">
                <v-list
                    three-line
                    subheader
                    class="elevation-4"
                >
                  <v-list-item>
                    <v-list-item-content>
                      <v-row class="d-flex justify-center">
                        <v-col
                            cols="12"
                            md="8"
                        >
                          <v-card class="elevation-4">
                            <v-card-title>
                              ข้อมูลส่วนตัว
                            </v-card-title>
                            <v-card-text v-if="staff_sel != null">
                              <v-avatar
                                  size="100px"
                                  v-if="staff_sel != null"
                                  style="border: 5px solid antiquewhite"
                                  class="ma-4"
                              >
                                <img
                                    :src="'https://medhr.medicine.psu.ac.th/ImageMED.php?pid=' + staff_sel.perid"
                                    :alt="staff_sel.full_Name"
                                >
                              </v-avatar>
                              <v-divider></v-divider>
                              <div>
                                <span style="font-weight: bold;font-size: 16px">รหัสบุคลากร : {{
                                    staff_sel.perid
                                  }}</span>
                              </div>
                              <div>
                                <span
                                    style="font-weight: bold;font-size: 16px">ชื่อ - สกุล : {{
                                    staff_sel.full_Name
                                  }}</span>
                              </div>
                              <div>
                                <span style="font-weight: bold;font-size: 16px">หน่วยงาน : {{
                                    staff_sel.dep_name
                                  }}</span>
                              </div>
                              <div>
                                <span style="font-weight: bold;font-size: 16px">ตำแหน่ง : {{
                                    staff_sel.pos_name
                                  }}</span>
                              </div>
                              <div v-if="levelData.filter(item => item.LevelCode == staff_sel.lv_id).length > 0">
                                <span
                                    style="font-weight: bold;font-size: 16px">ระดับ : {{
                                    levelData.filter(item => item.LevelCode == staff_sel.lv_id)[0].LevelName
                                  }}</span>
                              </div>
                              <div>
                                <span style="font-weight: bold;font-size: 16px">งบพัฒนาตนเองคงเหลือ : </span>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

              </v-tab-item>
              <v-tab-item
                  value="tab-2"
              >
                <div align="center">
                  <v-btn @click="showDialogInsertData('0')" color="green" outlined>
                    เพิ่มข้อมูลประวัติพัฒนา/ประชุม/อบรม/กา่รศึกษา
                  </v-btn>
                </div>
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <v-text-field label="ค้นหาโครงการ : วันที่ (ค.ศ.) ตัวอย่าง 2020-01-02 / ชื่อ / ประเภท"
                                v-model="searchTrain"></v-text-field>
                </v-list-item>
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <template>
                    <v-menu
                        v-model="showPickerSearchDateSTrain"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="searchDateStart"
                            label="วันที่เริ่มต้น"
                            hint="YYYY/MM/DD"
                            persistent-hint
                            readonly
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          locale="th"
                          v-model="searchDateStart"
                          no-title
                          @input="showPickerSearchDateSTrain = false"
                      ></v-date-picker>
                    </v-menu>
                  </template>
                  <v-spacer></v-spacer>
                  <template>
                    <v-menu
                        v-model="showPickerSearchDateETrain"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="searchDateEnd"
                            label="วันที่สิ้นสุด"
                            hint="YYYY/MM/DD"
                            persistent-hint
                            readonly
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          locale="th"
                          v-model="searchDateEnd"
                          no-title
                          @input="showPickerSearchDateETrain = false"
                      ></v-date-picker>
                    </v-menu>
                  </template>
                  <v-spacer></v-spacer>
                  <v-btn outlined color="primary" @click="filterDate('0')">
                    ค้นหา
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn outlined color="primary" @click="RestoreTrain">
                    แสดงทั้งหมด
                  </v-btn>
                  <v-spacer></v-spacer>
                  <download-excel
                      class="btn btn-default"
                      :data="json_data"
                      :fields="json_fields"
                      worksheet="ประวัติ พัฒนา/ฝึกอบรม/การศึกษา"
                      :name="'ข้อมูลประวัติ พัฒนา/ฝึกอบรม/การศึกษา คุณ ' + staff_sel.full_Name + '.xls'"
                      v-if="staff_sel != null"
                  >
                    <v-btn outlined color="green" class="darken-3" @click="ExportData">
                      Export ข้อมูล
                    </v-btn>
                  </download-excel>
                </v-list-item>
                <v-list
                    three-line
                    subheader
                >
                  <v-subheader>พัฒนา / ฝึกอบรม</v-subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <!--                    <v-list-item-title>Content filtering</v-list-item-title>-->
                      <!--                    <v-list-item-subtitle>Set the content filtering level to restrict apps that can be downloaded</v-list-item-subtitle>-->
                      <!--                    <v-data-table-->
                      <!--                        :headers="TrainHeader"-->
                      <!--                        :items="TrainHistory"-->
                      <!--                        show-expand-->
                      <!--                        :expanded.sync="expanded"-->
                      <!--                        :single-expand="singleExpand"-->
                      <!--                        item-key="idx"-->
                      <!--                    >-->
                      <v-data-table
                          :headers="TrainHeader"
                          :items="TrainHistory"
                          item-key="idx"
                          :sort-by="['date_start']"
                          :sort-desc="[true]"
                          :search="searchTrain"
                      >
                        <!--                        <template v-slot:item="{ item, expand, isExpanded }">-->
                        <template v-slot:item="{ item }">
                          <tr style="cursor: pointer" @click="ShowDetailData(item)" v-if="item.Train_Type == 'Custom'">
                            <td v-if="item.date_start != '0000-00-00'">
                              {{ item.date_start | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td v-if="item.date_end != '0000-00-00'">
                              {{ item.date_end | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td>
                              <span style="font-weight: bold;color: #364eff">{{ item.Subject }}</span>
                              <div v-if="item.Rm != '' && item.Rm != null">
                                : {{ item.Rm }}
                              </div>
                            </td>
                            <td>
                              {{ item.Type }}
                            </td>
                            <td>
                              <v-btn text @click="DeleteItemData(item)" color="red" class="darken-3">ลบ</v-btn>
                            </td>
                          </tr>

                          <tr v-else>
                            <!--                            <td>-->
                            <!--                              <v-btn @click="expand(!isExpanded)" text color="primary">ไฟล์</v-btn>-->
                            <!--                            </td>-->
                            <td v-if="item.date_start != '0000-00-00'">
                              {{ item.date_start | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td v-if="item.date_end != '0000-00-00'">
                              {{ item.date_end | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td>
                              <span style="font-weight: bold;color: #364eff">{{ item.Subject }}</span>
                              <div v-if="item.Rm != '' && item.Rm != null">
                                : {{ item.Rm }}
                              </div>
                            </td>
                            <td>
                              {{ item.Type }}
                            </td>
                            <td>
                            </td>
                          </tr>
                        </template>
                        <template v-slot:expanded-item="{ headers, item }">
                          <td :colspan="headers.length">
                            <div v-for="(file, idx) in item.files" v-bind:key="idx">
                              {{ item.files }}
                              <v-btn color="primary" text @click="ShowData(Openfile + file.File_path)">ไฟล์ :
                                {{ file.File_name }}
                              </v-btn>
                            </div>
                          </td>
                        </template>
                        <!--                      <template v-slot:item.date_start="{item}">-->
                        <!--                        <span>-->
                        <!--                          {{ item.date_start | dateToThai }}-->
                        <!--                        </span>-->
                        <!--                      </template>-->
                        <!--                      <template v-slot:item.date_end="{item}">-->
                        <!--                        <span>-->
                        <!--                          {{ item.date_end | dateToThai }}-->
                        <!--                        </span>-->
                        <!--                      </template>-->
                      </v-data-table>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-divider></v-divider>
              </v-tab-item>
              <v-tab-item
                  value="tab-3">
                <div align="center">
                  <v-btn @click="showDialogInsertData('1')" color="green" outlined>บันทึกข้อมูลคณะกรรมการ</v-btn>
                </div>
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <v-text-field label="ค้นหาคณะกรรมการ : วันที่ (ค.ศ.) ตัวอย่าง 2020-01-02 / ชื่อ / ประเภท"
                                v-model="searchCommit"></v-text-field>
                </v-list-item>
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <template>
                    <v-menu
                        v-model="showPickerSearchDateSCommit"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="searchDateStart"
                            label="วันที่เริ่มต้น"
                            hint="YYYY/MM/DD"
                            persistent-hint
                            readonly
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          locale="th"
                          v-model="searchDateStart"
                          no-title
                          @input="showPickerSearchDateSCommit = false"
                      ></v-date-picker>
                    </v-menu>
                  </template>
                  <v-spacer></v-spacer>
                  <template>
                    <v-menu
                        v-model="showPickerSearchDateECommit"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="searchDateEnd"
                            label="วันที่สิ้นสุด"
                            hint="YYYY/MM/DD"
                            persistent-hint
                            readonly
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          locale="th"
                          v-model="searchDateEnd"
                          no-title
                          @input="showPickerSearchDateECommit = false"
                      ></v-date-picker>
                    </v-menu>
                  </template>
                  <v-spacer></v-spacer>
                  <v-btn outlined color="primary" @click="filterDate('1')">
                    ค้นหา
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn outlined color="primary" @click="RestoreCommitt">
                    แสดงทั้งหมด
                  </v-btn>
                  <v-spacer></v-spacer>
                  <download-excel
                      class="btn btn-default"
                      :data="json_data"
                      :fields="json_fields"
                      worksheet="ประวัติกรรมการ"
                      :name="'ข้อมูลประวัติ กรรมการ คุณ ' + staff_sel.full_Name + '.xls'"
                      v-if="staff_sel != null"
                  >
                    <v-btn outlined color="green" class="darken-3" @click="ExportData">
                      Export ข้อมูล
                    </v-btn>
                  </download-excel>
                </v-list-item>
                <v-list
                    three-line
                    subheader
                >
                  <v-subheader>คณะกรรมการ</v-subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <!--                    <v-list-item-title>Content filtering</v-list-item-title>-->
                      <!--                    <v-list-item-subtitle>Set the content filtering level to restrict apps that can be downloaded</v-list-item-subtitle>-->
                      <v-data-table
                          :headers="TrainHeader"
                          :items="CommitHistory"
                          :sort-by="['date_start']"
                          :sort-desc="[true]"
                          :search="searchCommit"
                          @click:row="ShowDetailCommit"
                          item-key="idx"
                      >
                        <template v-slot:item="{ item }">
                          <tr style="cursor: pointer" @click="ShowDetailData(item)" v-if="item.Train_Type == 'Custom'">
                            <td v-if="item.date_start != '0000-00-00'">
                              {{ item.date_start | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td v-if="item.date_end != '0000-00-00'">
                              {{ item.date_end | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td>
                              <span style="font-weight: bold;color: #364eff">{{ item.Subject }}</span>
                              <div v-if="item.Rm != '' && item.Rm != null">
                                : {{ item.Rm }}
                              </div>
                            </td>
                            <td>
                              {{ item.Type }}
                            </td>
                            <td>
                              <v-btn text @click="DeleteItemData(item)" color="red" class="darken-3">ลบ</v-btn>
                            </td>
                          </tr>
                          <tr v-else>
                            <!--                            <td>-->
                            <!--                              <v-btn @click="expand(!isExpanded)" text color="primary">ไฟล์</v-btn>-->
                            <!--                            </td>-->
                            <td v-if="item.date_start != '0000-00-00'">
                              {{ item.date_start | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td v-if="item.date_end != '0000-00-00'">
                              {{ item.date_end | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td>
                              <span style="font-weight: bold;color: #364eff">{{ item.Subject }}</span>
                              <div v-if="item.Rm != '' && item.Rm != null">
                                : {{ item.Rm }}
                              </div>
                            </td>
                            <td>
                              {{ item.Type }}
                            </td>
                            <td>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-tab-item>
              <v-tab-item
                  value="tab-4">
                <div align="center">
                  <v-btn @click="showDialogInsertData('2')" color="green" outlined>เพิ่มข้อมูลวิทยากร / อาจารย์พิเศษ /
                    นำเสนอผลงาน
                  </v-btn>
                </div>
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <v-text-field
                      label="ค้นหาวิทยากร,อาจารย์พิเศษ,นำเสนอผลงาน : วันที่ (ค.ศ.) ตัวอย่าง 2020-01-02 / ชื่อ / ประเภท"
                      v-model="searchPresent"></v-text-field>
                </v-list-item>
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <template>
                    <v-menu
                        v-model="showPickerSearchDateSPresent"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="searchDateStart"
                            label="วันที่เริ่มต้น"
                            hint="YYYY/MM/DD"
                            persistent-hint
                            readonly
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          locale="th"
                          v-model="searchDateStart"
                          no-title
                          @input="showPickerSearchDateSPresent = false"
                      ></v-date-picker>
                    </v-menu>
                  </template>
                  <v-spacer></v-spacer>
                  <template>
                    <v-menu
                        v-model="showPickerSearchDateEPresent"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="searchDateEnd"
                            label="วันที่สิ้นสุด"
                            hint="YYYY/MM/DD"
                            persistent-hint
                            readonly
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          locale="th"
                          v-model="searchDateEnd"
                          no-title
                          @input="showPickerSearchDateEPresent = false"
                      ></v-date-picker>
                    </v-menu>
                  </template>
                  <v-spacer></v-spacer>
                  <v-btn outlined color="primary" @click="filterDate('2')">
                    ค้นหา
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn outlined color="primary" @click="RestorePresent">
                    แสดงทั้งหมด
                  </v-btn>
                  <v-spacer></v-spacer>
                  <download-excel
                      class="btn btn-default"
                      :data="json_data"
                      :fields="json_fields"
                      worksheet="วิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน"
                      :name="'ข้อมูลประวัติ วิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน คุณ ' + staff_sel.full_Name + '.xls'"
                      v-if="staff_sel != null"
                  >
                    <v-btn outlined color="green" class="darken-3" @click="ExportData">
                      Export ข้อมูล
                    </v-btn>
                  </download-excel>
                </v-list-item>
                <v-list
                    three-line
                    subheader
                >
                  <v-subheader>วิทยากร / อาจารย์พิเศษ / นำเสนอผลงาน</v-subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <!--                    <v-list-item-title>Content filtering</v-list-item-title>-->
                      <!--                    <v-list-item-subtitle>Set the content filtering level to restrict apps that can be downloaded</v-list-item-subtitle>-->
                      <v-data-table
                          :headers="TrainHeader"
                          :items="PresentHistory"
                          :sort-by="['date_start']"
                          :sort-desc="[true]"
                          :search="searchPresent"
                      >
                        <template v-slot:item="{ item }">
                          <tr style="cursor: pointer" @click="ShowDetailData(item)" v-if="item.Train_Type == 'Custom'">
                            <td v-if="item.date_start != '0000-00-00'">
                              {{ item.date_start | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td v-if="item.date_end != '0000-00-00'">
                              {{ item.date_end | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td>
                              <span style="font-weight: bold;color: #364eff">{{ item.Subject }}</span>
                              <div v-if="item.objData.CustomDetail != '' && item.objData.CustomDetail != null">
                                <div v-html="item.objData.CustomDetail"></div>
                                <template v-if="item.Rm != ''">
                                  <v-divider></v-divider>
                                  {{ item.Rm }}
                                </template>
                              </div>
                            </td>
                            <td>
                              {{ item.Type }}
                            </td>
                            <td>
                              <v-btn text @click="DeleteItemData(item)" color="red" class="darken-3">ลบ</v-btn>
                            </td>
                          </tr>
                          <tr v-else>
                            <!--                            <td>-->
                            <!--                              <v-btn @click="expand(!isExpanded)" text color="primary">ไฟล์</v-btn>-->
                            <!--                            </td>-->
                            <td v-if="item.date_start != '0000-00-00'">
                              {{ item.date_start | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td v-if="item.date_end != '0000-00-00'">
                              {{ item.date_end | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td>
                              <span style="font-weight: bold;color: #364eff">{{ item.Subject }}</span>
                              <div v-if="item.Rm != '' && item.Rm != null">
                                : {{ item.Rm }}
                              </div>
                            </td>
                            <td>
                              {{ item.Type }}
                            </td>
                            <td>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-tab-item>
              <v-tab-item
                  value="tab-5">
                <div align="center">
                  <v-btn @click="OpenDialogJournal" color="green" outlined>เพิ่มบทความ</v-btn>
                </div>
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <v-text-field label="ค้นหาบทความ : ปี ค.ศ. / ชื่อ / ประเภท" v-model="searchJournal"></v-text-field>
                </v-list-item>
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <download-excel
                      class="btn btn-default"
                      :data="json_data"
                      :fields="json_fields2"
                      worksheet="ประวัติบทความ"
                      :name="'ข้อมูลประวัติบทความ คุณ ' + staff_sel.full_Name + '.xls'"
                      v-if="staff_sel != null"
                  >
                    <v-btn outlined color="green" class="darken-3" @click="ExportData">
                      Export ข้อมูล
                    </v-btn>
                  </download-excel>
                </v-list-item>
                <v-list
                    three-line
                    subheader
                >
                  <v-subheader>บทความ</v-subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <!--                    <v-list-item-title>Content filtering</v-list-item-title>-->
                      <!--                    <v-list-item-subtitle>Set the content filtering level to restrict apps that can be downloaded</v-list-item-subtitle>-->
                      <v-data-table
                          :headers="JournalHeader"
                          :items="JournalHistory"
                          :sort-by="['date_start']"
                          :sort-desc="[true]"
                          :search="searchJournal"
                      >
                        <template v-slot:item="{item}">
                          <tr @click="EditJournal(item)" style="cursor: pointer">
                            <td>
                              {{ item.YearPrint }}
                            </td>
                            <td>
                              <span style="font-weight: bold;color: #364eff">{{ item.Journal }}</span>
                              <div v-if="item.Rm != '' && item.Rm != null">
                                : {{ item.Rm }}
                              </div>
                            </td>
                            <td>
                              <v-btn text @click="DeleteItemData2(item)" color="red" class="darken-3">ลบ</v-btn>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-tab-item>
              <v-tab-item
                  value="tab-6">
                <div align="center">
                  <v-btn @click="OpenDialogAward()" color="green" outlined>เพิ่มรางวัลพิเศษ</v-btn>
                </div>
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <v-text-field label="ค้นหารางวัลพิเศษ : ปี ค.ศ. / ชื่อ / ประเภท" v-model="searchAward"></v-text-field>
                </v-list-item>
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <download-excel
                      class="btn btn-default"
                      :data="json_data"
                      :fields="json_fields3"
                      worksheet="ประวัติรางวัลพิเศษ"
                      :name="'ข้อมูลประวัติรางวัลพิเศษ คุณ ' + staff_sel.full_Name + '.xls'"
                      v-if="staff_sel != null"
                  >
                    <v-btn outlined color="green" class="darken-3" @click="ExportData">
                      Export ข้อมูล
                    </v-btn>
                  </download-excel>
                </v-list-item>
                <v-list
                    three-line
                    subheader
                >
                  <v-subheader>รางวัลพิเศษ</v-subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <!--                    <v-list-item-title>Content filtering</v-list-item-title>-->
                      <!--                    <v-list-item-subtitle>Set the content filtering level to restrict apps that can be downloaded</v-list-item-subtitle>-->
                      <v-data-table
                          :headers="AwardHeader"
                          :items="AwardHistory"
                          :sort-by="['date_start']"
                          :sort-desc="[true]"
                          :search="searchAward"
                      >
                        <template v-slot:item="{item}">
                          <tr @click="EditAward(item)" style="cursor: pointer">
                            <td>
                              {{ item.AwYear }}
                            </td>
                            <td>
                              <span style="font-weight: bold;color: #364eff">{{ item.AwName }}</span>
                              <div v-if="item.Rm != '' && item.Rm != null">
                                : {{ item.Rm }}
                              </div>
                            </td>
                            <td>
                              {{ item.AwBy }}
                            </td>
                            <td>
                              {{ item.AwDetail }}
                            </td>
                            <td>
                              {{ item.AwDoc }}
                            </td>
                            <td>
                              <v-btn text @click="DeleteItemData3(item)" color="red" class="darken-3">ลบ</v-btn>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-tab-item>
              <v-tab-item
                  value="tab-7"
              >
                <div align="center">
                  <p style="font-size: 50px;font-weight: bold;margin-top: 150px">Coming Soon</p>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </v-sheet>


          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
      <template>
        <v-dialog
            v-model="dialogInsertData"
            fullscreen
            transition="dialog-bottom-transition"
        >
          <v-card style="padding-bottom: 20px">
            <v-card-title>
              <v-btn
                  icon
                  @click="dialogInsertData = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <span style="font-weight: bold;color: black">
                                        แบบฟอร์ม{{ Subject }}  <span
                  v-if="staff_sel != null">{{ staff_sel.full_Name }} ({{ staff_sel.perid }})</span>
                                      </span>
            </v-card-title>
            <v-card-text>
              <v-row class="d-flex justify-center">
                <v-col
                    cols="12"
                    md="8"
                    style="border: 1px solid black;border-radius: 3px"
                >
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-autocomplete label="เลือกประเภท" v-model="WorkGroupType"
                                        :items="dumpCommitData"
                                        item-text="committee_des"
                                        item-value="Committee_code"
                                        :error="WorkGroupType == ''"
                                        :error-messages="WorkGroupType == '' ? 'ประเภท ห้ามว่าง' : ''"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-text-field label="หัวข้อเรื่อง / หน้าที่" v-model="WorkGroupTypeSubject"
                                      :error="WorkGroupTypeSubject == ''"
                                      :error-messages="WorkGroupTypeSubject == '' ? 'หัวข้อเรื่อง / หน้าที่ ห้ามว่าง' : ''"
                        ></v-text-field>
                      </v-col>
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-text-field label="รหัสโครงการ (ถ้ามี)" v-model="WorkGroupProjectCode"
                                      @keyup="CheckProject()" v-if="TypeEdit != '0'"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <div align="center">
                    <v-alert
                        dense
                        outlined
                        type="error"
                        v-if="WorkGroupProjectCode != '' && !CheckProjectCode"
                    >
                    <span>
                      ไม่พบข้อมูลรหัสโครงการ {{ WorkGroupProjectCode }} ในระบบ
                    </span>
                    </v-alert>
                    <v-alert
                        dense
                        outlined
                        type="success"
                        v-if="WorkGroupProjectCode != '' && CheckProjectCode"
                    >
                    <span>
                   โครงการ : {{ this.WorkGroupProjectName }}
                    </span>
                    </v-alert>
                  </div>
                  <v-list-item
                      v-if="WorkGroupType == '6' || WorkGroupType == '13' || WorkGroupType == '14' || WorkGroupType == '23' || WorkGroupType == '24'">
                    <v-card style="width: 100%" color="#E0F2F1">
                      <v-card-subtitle>
                        <span style="color: #364eff" class="font-weight-bold">รายละเอียดเพิ่มเติมการเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน</span>
                      </v-card-subtitle>
                      <v-card-text>
                        <v-list-item>
                          <v-row>
                            <v-col
                                cols="12"
                                md="6">
                              <v-text-field
                                  v-model="LecturerProjectName"
                                  label="โครงการ"
                                  :error="LecturerProjectName == ''"
                                  :error-messages="LecturerProjectName == '' ? 'โครงการ' : ''"
                              ></v-text-field>
                            </v-col>
                            <v-col
                                cols="6"
                                md="3">
                              <v-text-field
                                  v-model="LecturerHour"
                                  label="จำนวน ช.ม."
                                  type="number"
                                  :error="LecturerHour == ''"
                                  :error-messages="LecturerHour == '' ? 'จำนวน ช.ม.' : ''"
                              ></v-text-field>
                            </v-col>
                            <v-col
                                cols="6"
                                md="3">
                              <v-text-field
                                  v-model="LecturerInvite"
                                  label="ผู้เชิญ"
                                  :error="LecturerInvite == ''"
                                  :error-messages="LecturerInvite == '' ? 'ผู้เชิญ' : ''"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item>
                          <v-row>
                            <v-col
                                cols="12"
                                md="3">
                              <template>
                                <v-menu
                                    v-model="showPickerLecturerDateStart"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="LecturerDateStart"
                                        label="วันที่เริ่มเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน"
                                        hint="YYYY/MM/DD"
                                        persistent-hint
                                        readonly
                                        :error="LecturerDateStart == ''"
                                        :error-messages="LecturerDateStart == '' ? 'วันที่เริ่มเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน' : ''"
                                        v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                      locale="th"
                                      v-model="LecturerDateStart"
                                      no-title
                                      @input="showPickerLecturerDateStart = false"
                                  ></v-date-picker>
                                </v-menu>
                              </template>
                            </v-col>
                            <v-col
                                cols="6"
                                md="3">
                              <v-text-field
                                  v-model="LecturerTimeStart"
                                  label="เวลาเริ่มการบรรยาย"
                                  :error="LecturerTimeStart == ''"
                                  :error-messages="LecturerTimeStart == '' ? 'เวลาเริ่มการบรรยาย' : ''"
                                  type="time"
                              ></v-text-field>
                            </v-col>
                            <v-col
                                cols="6"
                                md="3">
                              <template>
                                <v-menu
                                    v-model="showPickerLecturerDateEnd"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="LecturerDateEnd"
                                        label="วันที่สิ้นสุดเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน"
                                        hint="YYYY/MM/DD"
                                        persistent-hint
                                        readonly
                                        :error="LecturerDateEnd == ''"
                                        :error-messages="LecturerDateEnd == '' ? 'วันที่สิ้นสุดเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน' : ''"
                                        v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                      locale="th"
                                      v-model="LecturerDateEnd"
                                      no-title
                                      @input="showPickerLecturerDateEnd = false"
                                  ></v-date-picker>
                                </v-menu>
                              </template>
                            </v-col>
                            <v-col
                                cols="6"
                                md="3">
                              <v-text-field
                                  v-model="LecturerTimeEnd"
                                  label="เวลาสิ้นสุดการบรรยาย"
                                  type="time"
                                  :error="LecturerTimeEnd == ''"
                                  :error-messages="LecturerTimeEnd == '' ? 'เวลาสิ้นสุดการบรรยาย' : ''"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item>
                          <v-row>
                            <v-col
                                cols="12"
                                md="4">
                              <v-text-field
                                  v-model="LecturerPlace"
                                  label="สถานที่"
                                  :error="LecturerPlace == ''"
                                  :error-messages="LecturerPlace == '' ? 'สถานที่' : ''"
                              ></v-text-field>
                            </v-col>
                            <v-col
                                cols="6"
                                md="4">
                              <v-text-field
                                  v-model="LecturerDocNo"
                                  label="เลขที่หนังสือ"
                                  :error="LecturerDocNo == ''"
                                  :error-messages="LecturerDocNo == '' ? 'เลขที่หนังสือ' : ''"
                              ></v-text-field>
                            </v-col>
                            <v-col
                                cols="6"
                                md="4">
                              <template>
                                <v-menu
                                    v-model="showPickerLecturerDateDocOut"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="LecturerDateDocOut"
                                        label="วันที่ออกหนังสือ"
                                        hint="YYYY/MM/DD"
                                        persistent-hint
                                        readonly
                                        :error="LecturerDateDocOut == ''"
                                        :error-messages="LecturerDateDocOut == '' ? 'วันที่ออกหนังสือ' : ''"
                                        v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                      locale="th"
                                      v-model="LecturerDateDocOut"
                                      no-title
                                      @input="showPickerLecturerDateDocOut = false"
                                  ></v-date-picker>
                                </v-menu>
                              </template>
                            </v-col>
                          </v-row>
                        </v-list-item>
                      </v-card-text>
                    </v-card>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <template>
                          <v-menu
                              v-model="showPickerDateS"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                  v-model="WorkGroupDateS"
                                  label="วันที่เริ่มต้นจัดงาน"
                                  hint="YYYY/MM/DD"
                                  persistent-hint
                                  readonly
                                  :error="WorkGroupDateS == ''"
                                  :error-messages="WorkGroupDateS == '' ? 'วันที่เริ่มต้นจัดงาน ห้ามว่าง' : ''"
                                  v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                locale="th"
                                v-model="WorkGroupDateS"
                                no-title
                                @input="showPickerDateS = false"
                            ></v-date-picker>
                          </v-menu>
                        </template>
                        <!--                  <v-text-field type="date" label="วันที่เริ่มต้นจัดงาน"-->
                        <!--                                v-model="WorkGroupDateS"-->
                        <!--                                :error="WorkGroupDateS == ''"-->
                        <!--                                :error-messages="WorkGroupDateS == '' ? 'วันที่เริ่มต้นจัดงาน ห้ามว่าง' : ''"-->
                        <!--                  ></v-text-field>-->
                      </v-col>
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <template>
                          <v-menu
                              v-model="showPickerDateE"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                  v-model="WorkGroupDateE"
                                  label="วันที่สิ้นสุดจัดงาน"
                                  hint="YYYY/MM/DD"
                                  persistent-hint
                                  readonly
                                  v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                locale="th"
                                v-model="WorkGroupDateE"
                                no-title
                                @input="showPickerDateE = false"
                            ></v-date-picker>
                          </v-menu>
                        </template>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <template>
                          <v-menu
                              v-model="showPickerTravelDateS"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                  v-model="WorkTravelDateS"
                                  label="วันที่เดินทาง"
                                  hint="YYYY/MM/DD"
                                  persistent-hint
                                  readonly
                                  v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                locale="th"
                                v-model="WorkTravelDateS"
                                no-title
                                @input="showPickerTravelDateS = false"
                            ></v-date-picker>
                          </v-menu>
                        </template>
                      </v-col>
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <template>
                          <v-menu
                              v-model="showPickerTravelDateE"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                  v-model="WorkTravelDateE"
                                  label="วันที่สิ้นสุดจัดงาน"
                                  hint="YYYY/MM/DD"
                                  persistent-hint
                                  readonly
                                  v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                locale="th"
                                v-model="WorkTravelDateE"
                                no-title
                                @input="showPickerTravelDateE = false"
                            ></v-date-picker>
                          </v-menu>
                        </template>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-text-field type="time" label="เวลาเริ่มต้น"
                                      v-model="timeSForLecturer"></v-text-field>
                      </v-col>
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-text-field type="time" label="เวลาสิ้นสุด"
                                      v-model="timeEForLecturer"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="10">
                        <v-textarea label="รายละเอียดเพิ่มเติม (ถ้ามี)" outlined v-model="Rm"></v-textarea>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-file-input
                        v-model="files"
                        color="deep-purple accent-4"
                        counter
                        label="แนบไฟล์เอกสารประกอบ"
                        multiple
                        placeholder="เลือกไฟล์"
                        prepend-icon="mdi-paperclip"
                        outlined
                        :show-size="1000"
                        @change="FileSelect"
                    >
                      <template v-slot:selection="{ index, text }">
                        <v-chip
                            v-if="index < 5"
                            color="deep-purple accent-4"
                            dark
                            label
                            small
                        >
                          {{ text }}
                        </v-chip>

                        <span
                            v-else-if="index === 5"
                            class="overline grey--text text--darken-3 mx-2"
                        >
                                  +{{ files.length - 2 }} File(s)
                                </span>
                      </template>
                    </v-file-input>
                  </v-list-item>
                  <v-list-item>
                    <v-alert
                        v-if="alert"
                        prominent
                        type="error"
                    >
                      <v-row align="center" v-for="item in txtAlert" :key="item.id">
                        <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                      </v-row>
                    </v-alert>
                  </v-list-item>
                  <v-list-item v-if="FileProject.length > 0">
                    <template>
                      <v-row class="d-flex justify-center">
                        <v-col cols="12" md="12">
                          <v-list>
                            <v-list-item-title>
                              ไฟล์ภาพประกอบ
                            </v-list-item-title>
                            <v-list-item>
                              <v-data-table
                                  :items="FileProject"
                                  :headers="FileHeader"
                                  style="width: 100%"
                              >
                                <template v-slot:item.action="{ item }">
                                  <v-list-item class="justify-space-around">
                                    <v-btn text @click="ShowData(item.src)" color="green">
                                      เรียกดู
                                    </v-btn>
                                    <v-btn @click="DeleteFile2(item)" text color="red">
                                      ลบ
                                    </v-btn>
                                  </v-list-item>
                                </template>
                              </v-data-table>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </template>
                  </v-list-item>
                  <!--          <template v-if="TypeEdit == '0' || TypeEdit == '1'">-->
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col
                          cols="12"
                          md="4">
                        <v-autocomplete outlined
                                        label="เลือกบุคลากรผู้เข้าร่วม"
                                        :items="dumpStaff"
                                        item-text="customDetail"
                                        item-value="perid"
                                        v-model="staffSelToJoin"
                                        clearable
                                        @keyup="checkKeyEnter"
                        ></v-autocomplete>
                      </v-col>
                      <v-col
                          cols="12"
                          md="4" class="text-center">
                        <v-btn outlined color="green" class="darken-3" style="margin-top: 10px;font-weight: bold"
                               @click="AddJoinPerson">
                          เพิ่มผู้เข้าร่วม
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item class="d-flex justify-center">
                    <v-data-table
                        :headers="JoinPersonHeader"
                        :items="JoinPerson"
                    >
                      <template v-slot:item.action="{item}">
                        <div align="center" v-if="staff_sel != null">
                          <v-btn text @click="DelJoinProject(item)" color="red" v-if="item.perid != staff_sel.perid">
                            ลบ
                          </v-btn>
                        </div>
                      </template>
                    </v-data-table>
                  </v-list-item>
                  <!--          </template>-->
                  <div align="center">
                    <v-btn outlined color="primary" @click="AddWorkGuest" style="font-weight: bold">เพิ่มข้อมูล</v-btn>
                  </div>
                  <v-list-item>
                    <v-data-table
                        :headers="WorkGroupHeader"
                        :items="WorkGroup"
                        style="width: 100%"
                        show-expand
                        item-key="id"
                    >
                      <template v-slot:item.date_travel_start="{item}">
                  <span v-if="item.date_travel_start != '' && item.date_travel_start != null">{{
                      item.date_travel_start | dateToThai
                    }}</span>
                      </template>
                      <template v-slot:item.date_travel_end="{item}">
                  <span v-if="item.date_travel_end != '' && item.date_travel_end != null">{{
                      item.date_travel_end | dateToThai
                    }}</span>
                      </template>
                      <template v-slot:item.date_start="{item}">
                  <span v-if="item.date_start != '' && item.date_start != null">{{
                      item.date_start | dateToThai
                    }}</span>
                      </template>
                      <template v-slot:item.date_end="{item}">
                        <span v-if="item.date_end != '' && item.date_end != null">{{
                            item.date_end | dateToThai
                          }}</span>
                      </template>
                      <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                          <div v-if="item.JoinPerson.length > 0">
                      <span style="font-weight: bold">
                        รายชื่อผู้เข้าร่วม :
                      </span>
                          </div>
                          <div v-for="(person, idx) in item.JoinPerson" v-bind:key="idx">
                            {{ person.full_Name }}({{ person.perid }}) {{ person.dep_name }} {{ person.pos_name }}
                            <v-btn color="red" text @click="item.JoinPerson.splice(idx,1)"
                                   v-if="person.perid != staff_sel.perid">
                              ลบ
                            </v-btn>
                          </div>
                          <div v-if="item.Lecturer != null">
                        <span style="font-weight: bold">
                          รายละเอียดเพิ่มเติมการเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน (เพิ่มเติม)
                        </span>
                            <v-list-item>
                              โครงการ : {{ item.Lecturer.Project_name }}
                            </v-list-item>
                            <v-list-item>
                              จำนวน ช.ม. : {{ item.Lecturer.Hour }}
                            </v-list-item>
                            <v-list-item>
                              ผู้เชิญ : {{ item.Lecturer.Invite }}
                            </v-list-item>
                            <v-list-item>
                              วันที่เริ่มต้นเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน :
                              {{ item.Lecturer.DateStart | DateToThai }}
                            </v-list-item>
                            <v-list-item>
                              เวลาเริ่มการบรรยาย : {{ item.Lecturer.TimeStart }} น.
                            </v-list-item>
                            <v-list-item>
                              วันที่สิ้นสุดเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน : {{
                                item.Lecturer.DateEnd | DateToThai
                              }}
                            </v-list-item>
                            <v-list-item>
                              เวลาสิ้นสุดการบรรยาย : {{ item.Lecturer.TimeEnd }} น.
                            </v-list-item>
                            <v-list-item>
                              สถุานที่ : {{ item.Lecturer.Place }}
                            </v-list-item>
                            <v-list-item>
                              เลขที่หนังสือ : {{ item.Lecturer.DocNo }}
                            </v-list-item>
                            <v-list-item>
                              วันที่ออกหนังสือ : {{ item.Lecturer.DateDocNo }}
                            </v-list-item>
                          </div>
                          <div v-if="item.files.length > 0">
                      <span style="font-weight: bold">
                        ไฟล์ประกอบ :
                      </span>
                          </div>
                          <div v-for="(file, idx) in item.files" v-bind:key="idx">
                            <v-btn color="primary" text @click="ShowData(Openfile + file.path)">ไฟล์ : {{ file.name }}
                            </v-btn>
                          </div>
                          <div v-if="item.Rm != ''">
                      <span style="font-weight: bold">
                        รายละเอียด :
                      </span>
                          </div>
                          <div v-if="item.Rm != ''">
                            {{ item.Rm }}
                          </div>
                        </td>
                      </template>
                      <template v-slot:item.action="{item}">
                        <div align="center">
                          <v-btn text @click="GetOldData(item)" color="primary" style="font-weight: bold">
                            ใช้ข้อมูลเดิม
                          </v-btn>
                        </div>
                      </template>
                    </v-data-table>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  outlined
                  @click="SendDataToDb()"
                  style="font-weight: bold"
              >
                บันทึกข้อมูล
              </v-btn>
              <v-btn
                  color="red darken-1"
                  text
                  @click="dialogInsertData = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogInsertJournal"
            fullscreen
            transition="dialog-bottom-transition"
        >
          <v-card style="padding-bottom: 20px">
            <v-card-title>
              <v-btn
                  icon
                  @click="dialogInsertJournal = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <span style="font-weight: bold;color: black">
                                        แบบฟอร์มบันทึกข้อมูล บทความ  <span
                  v-if="staff_sel != null">{{ staff_sel.full_Name }} ({{ staff_sel.perid }})</span>
                                      </span>
            </v-card-title>
            <v-card-text>
              <v-row class="d-flex justify-center">
                <v-col
                    cols="12"
                    md="8"
                    style="border: 1px solid black;border-radius: 3px"
                >
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-text-field label="ปี ค.ศ." v-model="YearPrint" type="number"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="10">
                        <v-textarea label="รายละเอียด" v-model="Journal" outlined></v-textarea>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <div align="center">
                    <span style="font-weight: bold;text-align: center">
                      ชื่อหลัก
                    </span>
                  </div>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-radio-group v-model="MainName" row>
                          <v-radio
                              label="ใช่่"
                              value="True"
                          >
                          </v-radio>
                          <v-radio
                              label="ไม่ใช่"
                              value="False"
                          >
                          </v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="10">
                        <v-textarea label="รายละเอียดเพิ่มเติม (ถ้ามี)" outlined v-model="Rm"></v-textarea>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-file-input
                        v-model="files"
                        color="deep-purple accent-4"
                        counter
                        label="แนบไฟล์เอกสารประกอบ"
                        multiple
                        placeholder="เลือกไฟล์"
                        prepend-icon="mdi-paperclip"
                        outlined
                        :show-size="1000"
                        @change="FileSelect"
                    >
                      <template v-slot:selection="{ index, text }">
                        <v-chip
                            v-if="index < 5"
                            color="deep-purple accent-4"
                            dark
                            label
                            small
                        >
                          {{ text }}
                        </v-chip>

                        <span
                            v-else-if="index === 5"
                            class="overline grey--text text--darken-3 mx-2"
                        >
                                  +{{ files.length - 2 }} File(s)
                                </span>
                      </template>
                    </v-file-input>
                  </v-list-item>
                  <v-list-item>
                    <v-alert
                        v-if="alert"
                        prominent
                        type="error"
                    >
                      <v-row align="center" v-for="item in txtAlert" :key="item.id">
                        <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                      </v-row>
                    </v-alert>
                  </v-list-item>
                  <v-list-item v-if="FileProject.length > 0">
                    <template>
                      <v-row class="d-flex justify-center">
                        <v-col cols="12" md="12">
                          <v-list>
                            <v-list-item-title>
                              ไฟล์ภาพประกอบ
                            </v-list-item-title>
                            <v-list-item>
                              <v-data-table
                                  :items="FileProject"
                                  :headers="FileHeader"
                                  style="width: 100%"
                              >
                                <template v-slot:item.action="{ item }">
                                  <v-list-item class="justify-space-around">
                                    <v-btn text @click="ShowData(item.src)" color="green">
                                      เรียกดู
                                    </v-btn>
                                    <v-btn @click="DeleteFile2(item)" text color="red">
                                      ลบ
                                    </v-btn>
                                  </v-list-item>
                                </template>
                              </v-data-table>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </template>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col
                          cols="12"
                          md="4">
                        <v-autocomplete outlined
                                        label="เลือกบุคลากรผู้เข้าร่วม"
                                        :items="dumpStaff"
                                        item-text="customDetail"
                                        item-value="perid"
                                        v-model="staffSelToJoin"
                                        clearable
                                        @keyup="checkKeyEnter"
                        ></v-autocomplete>
                      </v-col>
                      <v-col
                          cols="12"
                          md="4" class="text-center">
                        <v-btn outlined color="green" class="darken-3" style="margin-top: 10px" @click="AddJoinPerson">
                          เพิ่มผู้เข้าร่วม
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item class="d-flex justify-center">
                    <v-data-table
                        :headers="JoinPersonHeader"
                        :items="JoinPerson"
                    >
                      <template v-slot:item.action="{item}">
                        <div align="center" v-if="staff_sel != null">
                          <v-btn text @click="DelJoinProject(item)" color="red" v-if="item.perid != staff_sel.perid">
                            ลบ
                          </v-btn>
                        </div>
                      </template>
                    </v-data-table>
                  </v-list-item>
                  <div align="center">
                    <v-btn outlined color="primary" @click="AddJournalDump">เพิ่มข้อมูล</v-btn>
                  </div>
                  <v-list-item>
                    <v-spacer></v-spacer>
                    <span>
                ข้อมูลบทความ {{ JournalDump.length }} รายการ
              </span>
                  </v-list-item>
                  <v-list-item>
                    <v-data-table
                        :headers="JournalHeader"
                        :items="JournalDump"
                        style="width: 100%"
                        show-expand
                        item-key="id"
                    >
                      <template v-slot:item.MainName="{ item }">
                        <template v-if="item.MainName == 'True'">
                          <span>ใช่</span>
                        </template>
                        <template v-else>
                          <span>ไม่ใช่</span>
                        </template>
                      </template>
                      <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                          <div v-if="item.JoinPerson.length > 0">
                      <span style="font-weight: bold">
                        รายชื่อผู้เข้าร่วม :
                      </span>
                          </div>
                          <div v-for="(person, idx) in item.JoinPerson" v-bind:key="idx">
                            {{ person.full_Name }}({{ person.perid }}) {{ person.dep_name }} {{ person.pos_name }}
                            <v-btn color="red" text @click="item.JoinPerson.splice(idx,1)"
                                   v-if="person.perid != staff_sel.perid">
                              ลบ
                            </v-btn>
                          </div>
                          <div v-for="(file, idx) in item.files" v-bind:key="idx">
                            <v-btn color="primary" text @click="ShowData(Openfile + file.path)">ไฟล์ : {{ file.name }}
                            </v-btn>
                          </div>
                        </td>
                      </template>
                    </v-data-table>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  outlined
                  @click="AddJournalData()"
              >
                บันทึกข้อมูล
              </v-btn>
              <v-btn
                  color="red darken-1"
                  text
                  @click="dialogInsertJournal = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogEditJournal"
            fullscreen
            transition="dialog-bottom-transition"
        >
          <v-card style="padding-bottom: 20px">
            <v-card-title>
              <v-btn
                  icon
                  @click="dialogEditJournal = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <span style="font-weight: bold;color: black">
                                        รายละเอียดข้อมูล บทความ  <span
                  v-if="staff_sel != null">{{ staff_sel.full_Name }} ({{ staff_sel.perid }})</span>
                                      </span>
            </v-card-title>
            <v-card-text>
              <v-row class="d-flex justify-center">
                <v-col
                    cols="12"
                    md="8"
                    style="border: 1px solid black;border-radius: 3px"
                >
                  <v-list-item class="d-flex justify-center">
                    <v-checkbox label="แก้ไขข้อมูล" color="yellow" class="darken-3" v-model="ChkEditData"></v-checkbox>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-text-field label="ปี ค.ศ." v-model="YearPrint" type="number" :readonly="!ChkEditData"
                                      v-if="YearPrint != ''"></v-text-field>
                        <v-text-field label="ปี ค.ศ." v-model="YearPrint" type="number" :readonly="!ChkEditData"
                                      v-else-if="ChkEditData"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="10">
                        <v-textarea label="รายละเอียด" v-model="Journal" outlined :readonly="!ChkEditData"
                                    v-if="YearPrint != ''"></v-textarea>
                        <v-textarea label="รายละเอียด" v-model="Journal" outlined :readonly="!ChkEditData"
                                    v-else-if="ChkEditData"></v-textarea>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <div align="center">
                          <span style="font-weight: bold;text-align: center">
                            ชื่อหลัก
                          </span>
                  </div>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-radio-group v-model="MainName" row :readonly="!ChkEditData" v-if="MainName != ''">
                          <v-radio
                              label="ใช่่"
                              value="True"
                          >
                          </v-radio>
                          <v-radio
                              label="ไม่ใช่"
                              value="False"
                          >
                          </v-radio>
                        </v-radio-group>
                        <v-radio-group v-model="MainName" row :readonly="!ChkEditData" v-else-if="ChkEditData">
                          <v-radio
                              label="ใช่่"
                              value="True"
                          >
                          </v-radio>
                          <v-radio
                              label="ไม่ใช่"
                              value="False"
                          >
                          </v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="10">
                        <v-textarea label="รายละเอียดเพิ่มเติม (ถ้ามี)" outlined v-model="Rm" :readonly="!ChkEditData"
                                    v-if="Rm != ''"></v-textarea>
                        <v-textarea label="รายละเอียดเพิ่มเติม (ถ้ามี)" outlined v-model="Rm" :readonly="!ChkEditData"
                                    v-else-if="ChkEditData"></v-textarea>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <div v-if="FileToShow.length > 0">
                    <v-list-item>
                      <span style="font-weight: bold">
                        ไฟล์ประกอบ
                      </span>
                    </v-list-item>
                    <div v-for="(file, idx) in FileToShow" v-bind:key="idx">
                      <v-btn text color="primary" class="darken-4" @click="ShowData(Openfile + file.File_path)">ไฟล์ที่
                        {{ idx + 1 }} : {{ file.File_name }}
                      </v-btn>
                      <v-btn color="red" @click="Del_file(file, idx)" class="ml-4" text v-if="ChkEditData">ลบ</v-btn>
                    </div>
                  </div>
                  <div v-if="ChkEditData" style="margin-top: 25px">
                    <v-list-item>
                      <v-file-input
                          v-model="files"
                          color="deep-purple accent-4"
                          counter
                          label="แนบไฟล์เอกสารประกอบ"
                          multiple
                          placeholder="เลือกไฟล์"
                          prepend-icon="mdi-paperclip"
                          outlined
                          :show-size="1000"
                          @change="FileSelect"
                      >
                        <template v-slot:selection="{ index, text }">
                          <v-chip
                              v-if="index < 5"
                              color="deep-purple accent-4"
                              dark
                              label
                              small
                          >
                            {{ text }}
                          </v-chip>

                          <span
                              v-else-if="index === 5"
                              class="overline grey--text text--darken-3 mx-2"
                          >
                                        +{{ files.length - 2 }} File(s)
                                      </span>
                        </template>
                      </v-file-input>
                    </v-list-item>
                    <v-list-item>
                      <v-alert
                          v-if="alert"
                          prominent
                          type="error"
                      >
                        <v-row align="center" v-for="item in txtAlert" :key="item.id">
                          <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                        </v-row>
                      </v-alert>
                    </v-list-item>
                    <v-list-item v-if="FileProject.length > 0">
                      <template>
                        <v-row class="d-flex justify-center">
                          <v-col cols="12" md="12">
                            <v-list>
                              <v-list-item-title>
                                ไฟล์ภาพประกอบ
                              </v-list-item-title>
                              <v-list-item>
                                <v-data-table
                                    :items="FileProject"
                                    :headers="FileHeader"
                                    style="width: 100%"
                                >
                                  <template v-slot:item.action="{ item }">
                                    <v-list-item class="justify-space-around">
                                      <v-btn text @click="ShowData(item.src)" color="green">
                                        เรียกดู
                                      </v-btn>
                                      <v-btn @click="DeleteFile2(item)" text color="red">
                                        ลบ
                                      </v-btn>
                                    </v-list-item>
                                  </template>
                                </v-data-table>
                              </v-list-item>
                            </v-list>
                          </v-col>
                        </v-row>
                      </template>
                    </v-list-item>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  outlined
                  @click="EditJournalData()"
              >
                บันทึกข้อมูล
              </v-btn>
              <v-btn
                  color="red darken-1"
                  text
                  @click="dialogEditJournal = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogInsertAward"
            fullscreen
            transition="dialog-bottom-transition"
        >
          <v-card style="padding-bottom: 20px">
            <v-card-title>
              <v-btn
                  icon
                  @click="dialogInsertAward = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <span style="font-weight: bold;color: black">
                                        แบบฟอร์มบันทึกข้อมูล รางวัลพิเศษ  <span
                  v-if="staff_sel != null">{{ staff_sel.full_Name }} ({{ staff_sel.perid }})</span>
                                      </span>
            </v-card-title>
            <v-card-text>
              <v-row class="d-flex justify-center">
                <v-col
                    cols="12"
                    md="8"
                    style="border: 1px solid black;border-radius: 3px"
                >
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-text-field label="ปี พ.ศ." v-model="AwYear" type="number"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-textarea label="ชื่อรางวัล" v-model="AwName" outlined></v-textarea>
                      </v-col>
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-textarea label="หน่วยงานที่ให้รางวัล" v-model="AwBy" outlined></v-textarea>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-text-field label="งาน/ สถานที่มอบ" v-model="AwDetail" outlined></v-text-field>
                      </v-col>
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-text-field label="เอกสารอ้างอิง" v-model="AwDoc" outlined></v-text-field>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="10">
                        <v-textarea label="รายละเอียดเพิ่มเติม (ถ้ามี)" outlined v-model="Rm"></v-textarea>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-file-input
                        v-model="files"
                        color="deep-purple accent-4"
                        counter
                        label="แนบไฟล์เอกสารประกอบ"
                        multiple
                        placeholder="เลือกไฟล์"
                        prepend-icon="mdi-paperclip"
                        outlined
                        :show-size="1000"
                        @change="FileSelect"
                    >
                      <template v-slot:selection="{ index, text }">
                        <v-chip
                            v-if="index < 5"
                            color="deep-purple accent-4"
                            dark
                            label
                            small
                        >
                          {{ text }}
                        </v-chip>

                        <span
                            v-else-if="index === 5"
                            class="overline grey--text text--darken-3 mx-2"
                        >
                                        +{{ files.length - 2 }} File(s)
                                      </span>
                      </template>
                    </v-file-input>
                  </v-list-item>
                  <v-list-item>
                    <v-alert
                        v-if="alert"
                        prominent
                        type="error"
                    >
                      <v-row align="center" v-for="item in txtAlert" :key="item.id">
                        <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                      </v-row>
                    </v-alert>
                  </v-list-item>
                  <v-list-item v-if="FileProject.length > 0">
                    <template>
                      <v-row class="d-flex justify-center">
                        <v-col cols="12" md="12">
                          <v-list>
                            <v-list-item-title>
                              ไฟล์ภาพประกอบ
                            </v-list-item-title>
                            <v-list-item>
                              <v-data-table
                                  :items="FileProject"
                                  :headers="FileHeader"
                                  style="width: 100%"
                              >
                                <template v-slot:item.action="{ item }">
                                  <v-list-item class="justify-space-around">
                                    <v-btn text @click="ShowData(item.src)" color="green">
                                      เรียกดู
                                    </v-btn>
                                    <v-btn @click="DeleteFile2(item)" text color="red">
                                      ลบ
                                    </v-btn>
                                  </v-list-item>
                                </template>
                              </v-data-table>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </template>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col
                          cols="12"
                          md="4">
                        <v-autocomplete outlined
                                        label="เลือกบุคลากรผู้เข้าร่วม"
                                        :items="dumpStaff"
                                        item-text="customDetail"
                                        item-value="perid"
                                        v-model="staffSelToJoin"
                                        clearable
                                        @keyup="checkKeyEnter"
                        ></v-autocomplete>
                      </v-col>
                      <v-col
                          cols="12"
                          md="4" class="text-center">
                        <v-btn outlined color="green" class="darken-3" style="margin-top: 10px" @click="AddJoinPerson">
                          เพิ่มผู้เข้าร่วม
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item class="d-flex justify-center">
                    <v-data-table
                        :headers="JoinPersonHeader"
                        :items="JoinPerson"
                    >
                      <template v-slot:item.action="{item}">
                        <div align="center" v-if="staff_sel != null">
                          <v-btn text @click="DelJoinProject(item)" color="red" v-if="item.perid != staff_sel.perid">
                            ลบ
                          </v-btn>
                        </div>
                      </template>
                    </v-data-table>
                  </v-list-item>
                  <div align="center">
                    <v-btn outlined color="primary" @click="AddAwardDump">เพิ่มข้อมูล</v-btn>
                  </div>
                  <v-list-item>
                    <v-spacer></v-spacer>
                    <span>
                      ข้อมูลบทความ {{ AwardDump.length }} รายการ
                    </span>
                  </v-list-item>
                  <v-list-item>
                    <v-data-table
                        :headers="AwardHeader"
                        :items="AwardDump"
                        style="width: 100%"
                        show-expand
                        item-key="id"
                    >
                      <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                          <div v-for="(file, idx) in item.files" v-bind:key="idx">
                            <v-btn color="primary" text @click="ShowData(Openfile + file.path)">ไฟล์ : {{ file.name }}
                            </v-btn>
                          </div>
                        </td>
                      </template>
                    </v-data-table>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  outlined
                  @click="AddAwardData()"
              >
                บันทึกข้อมูล
              </v-btn>
              <v-btn
                  color="red darken-1"
                  text
                  @click="dialogInsertAward = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogEditAward"
            fullscreen
            transition="dialog-bottom-transition"
        >
          <v-card style="padding-bottom: 20px">
            <v-card-title>
              <v-btn
                  icon
                  @click="dialogEditAward = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <span style="font-weight: bold;color: black">
                                        รายละเอียดข้อมูล รางวัลพิเศษ  <span
                  v-if="staff_sel != null">{{ staff_sel.full_Name }} ({{ staff_sel.perid }})</span>
                                      </span>
            </v-card-title>
            <v-card-text>
              <v-row class="d-flex justify-center">
                <v-col
                    cols="12"
                    md="8"
                    style="border: 1px solid black;border-radius: 3px"
                >
                  <v-list-item class="d-flex justify-center">
                    <v-checkbox label="แก้ไขข้อมูล" color="yellow" class="darken-3" v-model="ChkEditData"></v-checkbox>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-text-field label="ปี พ.ศ." v-model="AwYear" type="number" :readonly="!ChkEditData"
                                      v-if="AwYear != ''"></v-text-field>
                        <v-text-field label="ปี พ.ศ." v-model="AwYear" type="number" :readonly="!ChkEditData"
                                      v-else-if="ChkEditData"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-textarea label="ชื่อรางวัล" v-model="AwName" outlined :readonly="!ChkEditData"
                                    v-if="AwName != ''"></v-textarea>
                        <v-textarea label="ชื่อรางวัล" v-model="AwName" outlined :readonly="!ChkEditData"
                                    v-else-if="ChkEditData"></v-textarea>
                      </v-col>
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-textarea label="หน่วยงานที่ให้รางวัล" v-model="AwBy" outlined :readonly="!ChkEditData"
                                    v-if="AwBy != ''"></v-textarea>
                        <v-textarea label="หน่วยงานที่ให้รางวัล" v-model="AwBy" outlined :readonly="!ChkEditData"
                                    v-else-if="ChkEditData"></v-textarea>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-text-field label="งาน/ สถานที่มอบ" v-model="AwDetail" outlined :readonly="!ChkEditData"
                                      v-if="AwDetail != ''"></v-text-field>
                        <v-text-field label="งาน/ สถานที่มอบ" v-model="AwDetail" outlined :readonly="!ChkEditData"
                                      v-else-if="ChkEditData"></v-text-field>
                      </v-col>
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-text-field label="เอกสารอ้างอิง" v-model="AwDoc" outlined :readonly="!ChkEditData"
                                      v-if="AwDoc != ''"></v-text-field>
                        <v-text-field label="เอกสารอ้างอิง" v-model="AwDoc" outlined :readonly="!ChkEditData"
                                      v-else-if="ChkEditData"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="10">
                        <v-textarea label="รายละเอียดเพิ่มเติม (ถ้ามี)" outlined v-model="Rm" :readonly="!ChkEditData"
                                    v-if="Rm != ''"></v-textarea>
                        <v-textarea label="รายละเอียดเพิ่มเติม (ถ้ามี)" outlined v-model="Rm" :readonly="!ChkEditData"
                                    v-else-if="ChkEditData"></v-textarea>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <div v-if="FileToShow.length > 0">
                    <v-list-item>
                      <span style="font-weight: bold">
                        ไฟล์ประกอบ
                      </span>
                    </v-list-item>
                    <div v-for="(file, idx) in FileToShow" v-bind:key="idx">
                      <v-btn text color="primary" class="darken-4" @click="ShowData(Openfile + file.File_path)">ไฟล์ที่
                        {{ idx + 1 }} : {{ file.File_name }}
                      </v-btn>
                      <v-btn color="red" @click="Del_file(file, idx)" class="ml-4" text v-if="ChkEditData">ลบ</v-btn>
                    </div>
                  </div>
                  <div style="margin-top: 25px" v-if="ChkEditData">
                    <v-list-item>
                      <v-file-input
                          v-model="files"
                          color="deep-purple accent-4"
                          counter
                          label="แนบไฟล์เอกสารประกอบ"
                          multiple
                          placeholder="เลือกไฟล์"
                          prepend-icon="mdi-paperclip"
                          outlined
                          :show-size="1000"
                          @change="FileSelect"
                      >
                        <template v-slot:selection="{ index, text }">
                          <v-chip
                              v-if="index < 5"
                              color="deep-purple accent-4"
                              dark
                              label
                              small
                          >
                            {{ text }}
                          </v-chip>

                          <span
                              v-else-if="index === 5"
                              class="overline grey--text text--darken-3 mx-2"
                          >
                                  +{{ files.length - 2 }} File(s)
                                </span>
                        </template>
                      </v-file-input>
                    </v-list-item>
                    <v-list-item>
                      <v-alert
                          v-if="alert"
                          prominent
                          type="error"
                      >
                        <v-row align="center" v-for="item in txtAlert" :key="item.id">
                          <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                        </v-row>
                      </v-alert>
                    </v-list-item>
                    <v-list-item v-if="FileProject.length > 0">
                      <template>
                        <v-row class="d-flex justify-center">
                          <v-col cols="12" md="12">
                            <v-list>
                              <v-list-item-title>
                                ไฟล์ภาพประกอบ
                              </v-list-item-title>
                              <v-list-item>
                                <v-data-table
                                    :items="FileProject"
                                    :headers="FileHeader"
                                    style="width: 100%"
                                >
                                  <template v-slot:item.action="{ item }">
                                    <v-list-item class="justify-space-around">
                                      <v-btn text @click="ShowData(item.src)" color="green">
                                        เรียกดู
                                      </v-btn>
                                      <v-btn @click="DeleteFile2(item)" text color="red">
                                        ลบ
                                      </v-btn>
                                    </v-list-item>
                                  </template>
                                </v-data-table>
                              </v-list-item>
                            </v-list>
                          </v-col>
                        </v-row>
                      </template>
                    </v-list-item>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  outlined
                  @click="EditAwardData()"
              >
                บันทึกข้อมูล
              </v-btn>
              <v-btn
                  color="red darken-1"
                  text
                  @click="dialogEditAward = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <!--    dialogShowDetail    -->

      <template>
        <v-dialog
            v-model="dialogShowDetail"
            fullscreen
            transition="dialog-bottom-transition"
        >
          <v-card style="padding-bottom: 20px">
            <v-card-title>
              <v-btn
                  icon
                  @click="dialogShowDetail = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <span style="font-weight: bold;color: black">
                                        รายละเอียดประกอบ
              </span>
            </v-card-title>
            <v-card-text>
              <v-row class="d-flex justify-center">
                <v-col
                    cols="12"
                    md="8"
                    style="border: 1px solid black;border-radius: 3px"
                >
                  <v-list-item class="d-flex justify-center">
                    <v-checkbox label="แก้ไขข้อมูล" color="yellow" class="darken-3" v-model="ChkEditData"></v-checkbox>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <!--                <v-autocomplete label="ประเภท" v-model="EditWorkGroupType"-->
                        <!--                                :items="dumpCommitData"-->
                        <!--                                item-text="committee_des"-->
                        <!--                                item-value="Committee_code"-->
                        <!--                                :error="EditWorkGroupType == ''"-->
                        <!--                                :error-messages="EditWorkGroupType == 'ประเภท ห้ามว่าง' ? '' : ''"-->
                        <!--                                :readonly="!ChkEditData"-->
                        <!--                ></v-autocomplete>-->
<!--                        <v-autocomplete label="ประเภท" v-model="EditWorkGroupType"-->
<!--                                        :items="dumpCommitData"-->
<!--                                        item-text="committee_des"-->
<!--                                        item-value="Committee_code"-->
<!--                                        :error="ChkEditData"-->
<!--                                        :error-messages="ChkEditData ? 'ไม่สามารถแก้ไขประเภทได้ !!' : ''"-->
<!--                                        :readonly="true"-->
<!--                        ></v-autocomplete>-->
                        <p style="font-size: 20px;font-weight: bold;color: #364eff" v-if="ObjEditData != null && ObjEditData.objData != null">
                          {{ObjEditData.objData.committee_des}}
                        </p>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-text-field label="หัวข้อเรื่อง / หน้าที่" v-model="EditWorkGroupTypeSubject"
                                      :error="EditWorkGroupTypeSubject == ''"
                                      :error-messages="EditWorkGroupTypeSubject == 'หัวข้อเรื่อง / หน้าที่ ห้ามว่าง' ? '' : ''"
                                      :readonly="!ChkEditData"
                        ></v-text-field>
                      </v-col>
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-text-field label="รหัสโครงการ" v-model="EditWorkGroupProjectCode"
                                      :readonly="!ChkEditData"
                                      @keyup="CheckProject2()" v-if="!CheckCordi"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <div align="center" v-if="!CheckCordi">
                    <v-alert
                        dense
                        outlined
                        type="error"
                        v-if="EditWorkGroupProjectCode != '' && !CheckProjectCode"
                    >
                          <span>
                            ไม่พบข้อมูลรหัสโครงการ {{ EditWorkGroupProjectCode }} ในระบบ
                          </span>
                    </v-alert>
                    <v-alert
                        dense
                        outlined
                        type="success"
                        v-if="EditWorkGroupProjectCode != '' && CheckProjectCode"
                    >
                          <span>
                            โครงการ : {{ this.EditWorkGroupProjectName }}
                          </span>
                    </v-alert>
                  </div>
                  <v-list-item
                      v-if="EditWorkGroupType == '6' || EditWorkGroupType == '13' || EditWorkGroupType == '14' || EditWorkGroupType == '23' || EditWorkGroupType == '24'">
                    <v-card style="width: 100%" color="#E0F2F1">
                      <v-card-subtitle>
                        <span style="color: #364eff" class="font-weight-bold">รายละเอียดเพิ่มเติมการเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน</span>
                      </v-card-subtitle>
                      <v-card-text>
                        <v-list-item>
                          <v-row>
                            <v-col
                                cols="12"
                                md="6">
                              <v-text-field
                                  v-model="EditLecturerProjectName"
                                  label="โครงการ"
                                  :error="EditLecturerProjectName == ''"
                                  :error-messages="EditLecturerProjectName == '' ? 'โครงการ' : ''"
                                  :readonly="!ChkEditData"
                              ></v-text-field>
                            </v-col>
                            <v-col
                                cols="6"
                                md="3">
                              <v-text-field
                                  v-model="EditLecturerHour"
                                  label="จำนวน ช.ม."
                                  type="number"
                                  :error="EditLecturerHour == ''"
                                  :error-messages="EditLecturerHour == '' ? 'จำนวน ช.ม.' : ''"
                                  :readonly="!ChkEditData"
                              ></v-text-field>
                            </v-col>
                            <v-col
                                cols="6"
                                md="3">
                              <v-text-field
                                  v-model="EditLecturerInvite"
                                  label="ผู้เชิญ"
                                  :error="EditLecturerInvite == ''"
                                  :error-messages="EditLecturerInvite == '' ? 'ผู้เชิญ' : ''"
                                  :readonly="!ChkEditData"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item>
                          <v-row>
                            <v-col
                                cols="12"
                                md="3">
                              <template>
                                <v-menu
                                    v-model="showPickerEditLecturerDateStart"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="EditLecturerDateStart"
                                        hint="YYYY/MM/DD"
                                        persistent-hint
                                        :readonly="!ChkEditData"
                                        label="วันที่เริ่มเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน"
                                        :error="EditLecturerDateStart == '' || EditLecturerDateStart == '0000-00-00'"
                                        :error-messages="EditLecturerDateStart == '' ? 'วันที่เริ่มเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน' : ''"
                                        v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                      locale="th"
                                      v-model="EditLecturerDateStart"
                                      no-title
                                      @input="showPickerEditLecturerDateStart = false"
                                  ></v-date-picker>
                                </v-menu>
                              </template>
                            </v-col>
                            <v-col
                                cols="6"
                                md="3">
                              <v-text-field

                                  v-model="EditLecturerTimeStart"
                                  label="เวลาเริ่มการบรรยาย"
                                  :error="EditLecturerTimeStart == ''"
                                  :error-messages="EditLecturerTimeStart == '' ? 'เวลาเริ่มการบรรยาย' : ''"
                                  type="time"
                                  :readonly="!ChkEditData"
                              ></v-text-field>
                            </v-col>
                            <v-col
                                cols="6"
                                md="3">
                              <template>
                                <v-menu
                                    v-model="showPickerEditLecturerDateEnd"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="EditLecturerDateEnd"
                                        hint="YYYY/MM/DD"
                                        persistent-hint
                                        label="วันที่สิ้นสุดเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน"
                                        :error="EditLecturerDateEnd == '' || EditLecturerDateEnd == '0000-00-00'"
                                        :error-messages="EditLecturerDateEnd == '' ? 'วันที่สิ้นสุดเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน' : ''"
                                        :readonly="!ChkEditData"
                                        v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                      locale="th"
                                      v-model="EditLecturerDateEnd"
                                      no-title
                                      @input="showPickerEditLecturerDateEnd = false"
                                  ></v-date-picker>
                                </v-menu>
                              </template>
                            </v-col>
                            <v-col
                                cols="6"
                                md="3">
                              <v-text-field
                                  v-model="EditLecturerTimeEnd"
                                  label="เวลาสิ้นสุดการบรรยาย"
                                  type="time"
                                  :error="EditLecturerTimeEnd == ''"
                                  :error-messages="EditLecturerTimeEnd == '' ? 'เวลาสิ้นสุดการบรรยาย' : ''"
                                  :readonly="!ChkEditData"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item>
                          <v-row>
                            <v-col
                                cols="12"
                                md="4">
                              <v-text-field
                                  v-model="EditLecturerPlace"
                                  label="สถานที่"
                                  :error="EditLecturerPlace == ''"
                                  :error-messages="EditLecturerPlace == '' ? 'สถานที่' : ''"
                                  :readonly="!ChkEditData"
                              ></v-text-field>
                            </v-col>
                            <v-col
                                cols="6"
                                md="4">
                              <v-text-field
                                  v-model="EditLecturerDocNo"
                                  label="เลขที่หนังสือ"
                                  :error="EditLecturerDocNo == ''"
                                  :error-messages="EditLecturerDocNo == '' ? 'เลขที่หนังสือ' : ''"
                                  :readonly="!ChkEditData"
                              ></v-text-field>
                            </v-col>
                            <v-col
                                cols="6"
                                md="4">
                              <template>
                                <v-menu
                                    v-model="showPickerEditLecturerDateDocOut"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="EditLecturerDateDocOut"
                                        hint="YYYY/MM/DD"
                                        persistent-hint
                                        label="วันที่ออกหนังสือ"
                                        :error="EditLecturerDateDocOut == ''"
                                        :error-messages="EditLecturerDateDocOut == '' ? 'วันที่ออกหนังสือ' : ''"
                                        :readonly="!ChkEditData"
                                        v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                      locale="th"
                                      v-model="EditLecturerDateDocOut"
                                      no-title
                                      @input="showPickerEditLecturerDateDocOut = false"
                                  ></v-date-picker>
                                </v-menu>
                              </template>
                            </v-col>
                          </v-row>
                        </v-list-item>
                      </v-card-text>
                    </v-card>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <template v-if="EditWorkGroupDateS != '' || ChkEditData">
                          <v-menu
                              v-model="showPickerEditDateS"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                              :readonly="!ChkEditData"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                  v-model="EditWorkGroupDateS"
                                  label="วันที่เริ่มต้นจัดงาน"
                                  hint="YYYY/MM/DD"
                                  persistent-hint
                                  :error="EditWorkGroupDateS == ''"
                                  :error-messages="EditWorkGroupDateS == 'วันที่เริ่มต้นจัดงาน ห้ามว่าง' ? '' : ''"
                                  :readonly="!ChkEditData"
                                  v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                locale="th"
                                v-model="EditWorkGroupDateS"
                                no-title
                                @input="showPickerEditDateS = false"
                                :readonly="!ChkEditData"
                            ></v-date-picker>
                          </v-menu>
                        </template>
                      </v-col>
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <template v-if="EditWorkGroupDateE != '' || ChkEditData">
                          <v-menu
                              v-model="showPickerEditDateE"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                              :readonly="!ChkEditData"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                  v-model="EditWorkGroupDateE"
                                  hint="YYYY/MM/DD"
                                  persistent-hint
                                  label="วันที่สิ้นสุดจัดงาน"
                                  :readonly="!ChkEditData"
                                  v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                locale="th"
                                v-model="EditWorkGroupDateE"
                                no-title
                                @input="showPickerEditDateE = false"
                                :readonly="!ChkEditData"
                            ></v-date-picker>
                          </v-menu>
                        </template>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <template v-if="EditWorkTravelDateS != '' || ChkEditData">
                          <v-menu
                              v-model="showPickerEditTravelDateS"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                              :readonly="!ChkEditData"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                  hint="YYYY/MM/DD"
                                  persistent-hint
                                  label="วันที่เริ่มต้นเดินทาง"
                                  v-model="EditWorkTravelDateS"
                                  :readonly="!ChkEditData"
                                  v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                locale="th"
                                v-model="EditWorkTravelDateS"
                                no-title
                                @input="showPickerEditTravelDateS = false"
                                :readonly="!ChkEditData"
                            ></v-date-picker>
                          </v-menu>
                        </template>
                      </v-col>
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <template v-if="EditWorkTravelDateE != '' || ChkEditData">
                          <v-menu
                              v-model="showPickerEditTravelDateE"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                              :readonly="!ChkEditData"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                  hint="YYYY/MM/DD"
                                  persistent-hint
                                  label="วันที่สิ้นสุดเดินทาง"
                                  v-model="EditWorkTravelDateE"
                                  :readonly="!ChkEditData"
                                  v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                locale="th"
                                v-model="EditWorkTravelDateE"
                                no-title
                                @input="showPickerEditTravelDateE = false"
                                :readonly="!ChkEditData"
                            ></v-date-picker>
                          </v-menu>
                        </template>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-text-field type="time" label="เวลาเริ่มต้น"
                                      v-model="EdittimeSForLecturer"
                                      :readonly="!ChkEditData"
                                      v-if="EdittimeSForLecturer != '00:00:00'"
                        ></v-text-field>
                        <v-text-field type="time" label="เวลาเริ่มต้น"
                                      v-model="EdittimeSForLecturer"
                                      :readonly="!ChkEditData"
                                      v-else-if="ChkEditData"
                        ></v-text-field>
                      </v-col>
                      <v-col class="d-flex justify-center" cols="12"
                             md="6">
                        <v-text-field type="time" label="เวลาสิ้นสุด"
                                      v-model="EdittimeEForLecturer"
                                      :readonly="!ChkEditData"
                                      v-if="EdittimeEForLecturer != '00:00:00'"
                        ></v-text-field>
                        <v-text-field type="time" label="เวลาสิ้นสุด"
                                      v-model="EdittimeEForLecturer"
                                      :readonly="!ChkEditData"
                                      v-else-if="ChkEditData"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12"
                             md="10">
                        <v-textarea label="รายละเอียดเพิ่มเติม (ถ้ามี)"
                                    outlined
                                    v-model="EditRm"
                                    :readonly="!ChkEditData"
                                    v-if="EditRm != ''"
                        ></v-textarea>
                        <v-textarea label="รายละเอียดเพิ่มเติม (ถ้ามี)"
                                    outlined
                                    v-model="EditRm"
                                    :readonly="!ChkEditData"
                                    v-else-if="ChkEditData"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <div v-if="FileToShow.length > 0">
                    <v-list-item>
                      <span style="font-weight: bold">
                        ไฟล์ประกอบ
                      </span>
                    </v-list-item>
                    <div v-for="(file, idx) in FileToShow" v-bind:key="idx">
                      <v-btn text color="primary" class="darken-4" @click="ShowData(Openfile + file.File_path)">ไฟล์ที่
                        {{ idx + 1 }} : {{ file.File_name }}
                      </v-btn>
                      <v-btn color="red" @click="Del_file(file, idx)" class="ml-4" text v-if="ChkEditData">ลบ</v-btn>
                    </div>
                  </div>
                  <div v-if="ChkEditData" style="margin-top: 25px">
                    <v-list-item>
                      <v-file-input
                          v-model="files"
                          color="deep-purple accent-4"
                          counter
                          label="แนบไฟล์เอกสารประกอบ"
                          multiple
                          placeholder="เลือกไฟล์"
                          prepend-icon="mdi-paperclip"
                          outlined
                          :show-size="1000"
                          @change="FileSelect"
                      >
                        <template v-slot:selection="{ index, text }">
                          <v-chip
                              v-if="index < 5"
                              color="deep-purple accent-4"
                              dark
                              label
                              small
                          >
                            {{ text }}
                          </v-chip>

                          <span
                              v-else-if="index === 5"
                              class="overline grey--text text--darken-3 mx-2"
                          >
                                        +{{ files.length - 2 }} File(s)
                                      </span>
                        </template>
                      </v-file-input>
                    </v-list-item>
                    <v-list-item>
                      <v-alert
                          v-if="alert"
                          prominent
                          type="error"
                      >
                        <v-row align="center" v-for="item in txtAlert" :key="item.id">
                          <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                        </v-row>
                      </v-alert>
                    </v-list-item>
                    <v-list-item v-if="FileProject.length > 0">
                      <template>
                        <v-row class="d-flex justify-center">
                          <v-col cols="12" md="12">
                            <v-list>
                              <v-list-item-title>
                                ไฟล์ภาพประกอบ
                              </v-list-item-title>
                              <v-list-item>
                                <v-data-table
                                    :items="FileProject"
                                    :headers="FileHeader"
                                    style="width: 100%"
                                >
                                  <template v-slot:item.action="{ item }">
                                    <v-list-item class="justify-space-around">
                                      <v-btn text @click="ShowData(item.src)" color="green">
                                        เรียกดู
                                      </v-btn>
                                      <v-btn @click="DeleteFile2(item)" text color="red">
                                        ลบ
                                      </v-btn>
                                    </v-list-item>
                                  </template>
                                </v-data-table>
                              </v-list-item>
                            </v-list>
                          </v-col>
                        </v-row>
                      </template>
                    </v-list-item>
                  </div>
                  <div align="center" v-if="ChkEditData">
                    <v-btn dark color="yellow" class="darken-4" @click="UpdateDataToDb">แก้ไขข้อมูล</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  outlined
                  @click="dialogShowDetail = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogExportHR"
            scrollable
            max-width="300px"
        >
          <v-card>
            <v-card-title>เลือกข้อมูลที่ต้องการ Export</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-radio-group
                  v-model="ExportXslx"
                  column
              >
                <v-radio
                    v-for="(xslx, idx) in ExportXslxData" :key="idx"
                    :label="xslx.text"
                    :value="xslx.value"
                ></v-radio>
              </v-radio-group>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="blue darken-1"
                  text
                  @click="dialogExportHR = false"
              >
                Close
              </v-btn>
              <download-excel
                  class="btn btn-default"
                  :data="json_Export"
                  :fields="json_fields_all"
                  worksheet="ประวัติรางวัลพิเศษ"
                  :name="'Train.xls'"
              >
                <v-btn outlined color="green" class="darken-3" @click="ExportAllData">
                  Export ข้อมูล
                </v-btn>
              </download-excel>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </template>
  </v-content>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import axios from "axios";
import ConstData from "@/const/Const";
import Vue from 'vue'


export default {
  name: "ManagePerson",
  data() {
    return {
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      showPickerSearchDateSTrain: false,
      showPickerSearchDateETrain: false,
      showPickerSearchDateSCommit: false,
      showPickerSearchDateECommit: false,
      showPickerSearchDateSPresent: false,
      showPickerSearchDateEPresent: false,
      showPickerDateS: false,
      showPickerDateE: false,
      showPickerTravelDateS: false,
      showPickerTravelDateE: false,
      showPickerEditDateS: false,
      showPickerEditDateE: false,
      showPickerEditTravelDateS: false,
      showPickerEditTravelDateE: false,
      showPickerLecturerDateStart: false,
      showPickerLecturerDateEnd: false,
      showPickerEditLecturerDateStart: false,
      showPickerEditLecturerDateEnd: false,
      showPickerLecturerDateDocOut: false,
      showPickerEditLecturerDateDocOut: false,
      maintain: false,
      LecturerDateStart: '',
      LecturerDateEnd: '',
      LecturerTimeStart: '',
      LecturerTimeEnd: '',
      LecturerDateDocOut: '',
      LecturerDocNo: '',
      LecturerPlace: '',
      LecturerInvite: '',
      LecturerHour: '',
      LecturerProjectName: '',
      EditLecturerDateStart: '',
      EditLecturerDateEnd: '',
      EditLecturerTimeStart: '',
      EditLecturerTimeEnd: '',
      EditLecturerDateDocOut: '',
      EditLecturerDocNo: '',
      EditLecturerPlace: '',
      EditLecturerInvite: '',
      EditLecturerHour: '',
      EditLecturerProjectName: '',
      CheckApprove: false,
      btnLoading: false,
      exportExec: false,
      Choice: '0',
      ChoiceExport: [
        {text: 'อบรม, ประชุม, ศึกษา, ดูงาน', value: '0'},
        {text: 'คณะกรรมการ', value: '1'},
        {text: 'วิทยากร, อาจารย์พิเศษ, นำเสนอผลงาน', value: '2'},
        {text: 'บทความ', value: '3'},
        {text: 'รางวัลพิเศษ', value: '4'},
      ],
      dateExStart: '',
      dateExEnd: '',
      dialogExportHR: false,
      ExportXslx: '',
      ExportXslxData: [
        {text: 'ประชุม', value: '15'},
        {text: 'การศึกษา', value: '16'},
        {text: 'ฝึกอบรม', value: '17'},
        {text: 'ดูงาน', value: '18'},
      ],
      json_fields: {
        'ลำดับ': 'index',
        "วันที่": 'date',
        "ประเภท": 'Type',
        "เรื่อง": 'Subject',
        "รายละเอียด": 'Rm',
      },
      json_fields_all: {
        'ลำดับ': 'idx',
        'รหัส': 'perid',
        'ชื่อ-สกุล': 'full_Name',
        "วันที่เริ่มต้น": 'date_start',
        "วันที่สิ้นสุด": 'date_end',
        "ประเภท": 'Type',
        "เรื่อง": 'Subject',
        "รายละเอียด": 'Rm',
      },
      json_Journal_all: {
        'ลำดับ': 'index',
        "ปี": 'YearPrint',
        "รายละเอียด": 'Journal',
        "ชื่อหลัก": 'Author_Detail',
        "รายละเอียด (เพิ่มเติม)": 'Rm',
        "รหัส": 'perid',
        "ชื่อ-สกุล": 'full_Name',
      },
      json_Extra_all: {
        'ลำดับ': 'index',
        "ปี": 'AwYear',
        "ชื่อรางวัล": 'AwName',
        "หน่วยงานที่ให้รางวัล": 'AwBy',
        "งาน / สถานที่มอบ": 'AwDetail',
        "เอกสารอ้างอิง": 'AwDoc',
        "รายละเอียด": 'Rm',
        "รหัส": 'perid',
        "ชื่อ-สกุล": 'full_Name',
      },
      json_fields2: {
        'ลำดับ': 'index',
        "ปี": 'YearPrint',
        "รายละเอียด": 'Journal',
        "ชื่อหลัก": 'Author_Detail',
        "รายละเอียด (เพิ่มเติม)": 'Rm',
      },
      json_fields3: {
        'ลำดับ': 'index',
        "ปี": 'AwYear',
        "ชื่อรางวัล": 'AwName',
        "หน่วยงานที่ให้รางวัล": 'AwBy',
        "งาน / สถานที่มอบ": 'AwDetail',
        "เอกสารอ้างอิง": 'AwDoc',
        "รายละเอียด": 'Rm',
      },
      json_data: [],
      json_Export: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      JoinPerson: [],
      JoinPersonHeader: [
        {text: 'รหัสบุคลากร', value: 'perid'},
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'หน่วยงาน', value: 'dep_name'},
        {text: 'ตำแหน่ง', value: 'pos_name'},
        {text: '', value: 'action'},
      ],
      staffSelToJoin: '',
      searchDateStart: '',
      searchDateEnd: '',
      DumpDataTrain: [],
      DumpDataCommittee: [],
      DumpDataPresent: [],
      SortData: [],
      dialogEditAward: false,
      dialogEditJournal: false,
      searchAward: '',
      searchJournal: '',
      searchPresent: '',
      searchCommit: '',
      searchTrain: '',
      ObjEditData: null,
      FileToShow: [],
      CheckCordi: false,
      ChkEditData: false,
      TypeEdit: '',
      Subject: '',
      Rm: '',
      EditRm: '',
      dumpCommitData: [],
      AwardDump: [],
      AwYear: '',
      AwBy: '',
      AwName: '',
      AwDetail: '',
      AwDoc: '',
      JournalDump: [],
      MainName: 'False',
      YearPrint: '',
      Journal: '',
      Author: false,
      dialogInsertJournal: false,
      dialogInsertAward: false,
      JournalHeader: [
        {text: 'ปี ค.ศ.', value: 'YearPrint'},
        {text: 'รายละเอียด', value: 'Journal'},
        {text: 'ชื่อหลัก', value: 'MainName'},
        {text: '', value: 'action'},
      ],
      JournalHistory: [],
      AwardHeader: [
        {text: 'ปี พ.ศ.', value: 'AwYear'},
        {text: 'ชื่อรางวัล', value: 'AwName'},
        {text: 'หน่วยงานที่ให้รางวัล', value: 'AwBy'},
        {text: 'งาน/ สถานที่มอบ', value: 'AwDetail'},
        {text: 'เอกสารอ้างอิง', value: 'AwDoc'},
        {text: '', value: 'action'},
      ],
      AwardHistory: [],
      dialogShowDetail: false,
      staff_sel_choose: '',
      dumpStaff: [],
      Openfile: ConstData.ConnectionHost + '/rest/files',
      expanded: [],
      singleExpand: true,
      EditWorkTravelDateS: '',
      EditWorkTravelDateE: '',
      WorkTravelDateS: '',
      WorkTravelDateE: '',
      alert: false,
      files: [],
      FileProject: [],
      WorkGroupHeader: [
        {text: 'หัวข้อเรื่อง/หน้าที่', value: 'subject'},
        {text: 'หน้าที่', value: 'type_name'},
        {text: 'รหัสโครงการ', value: 'Project_code'},
        {text: 'วันที่จัดงานเริ่มต้น', value: 'date_start'},
        {text: 'วันที่จัดงานสิ้นสุด', value: 'date_end'},
        {text: 'วันที่เดินทาง', value: 'date_travel_start'},
        {text: 'วันที่กลับ', value: 'date_travel_end'},
        {text: 'เวลาเริ่มต้น', value: 'time_start'},
        {text: 'เวลาสิ้นสุด', value: 'time_end'},
        {text: '', value: 'action'},
      ],
      FileHeader: [
        {text: 'ชื่อไฟล์', value: 'name'},
        {text: 'ประเภทไฟล์', value: 'type'},
        {text: '', value: 'action'},
      ],
      WorkGroup: [],
      CheckProjectCode: false,
      CommittType: [],
      EditWorkGroupType: '',
      EditWorkGroupTypeSubject: '',
      EditWorkGroupProjectCode: '',
      EditWorkGroupProjectName: '',
      EditWorkGroupDateS: '',
      EditWorkGroupDateE: '',
      EdittimeSForLecturer: '',
      EdittimeEForLecturer: '',
      WorkGroupType: '',
      WorkGroupTypeSubject: '',
      WorkGroupProjectCode: '',
      WorkGroupProjectName: '',
      WorkGroupDateS: '',
      WorkGroupDateE: '',
      timeSForLecturer: '',
      timeEForLecturer: '',
      TrainHistory: [],
      CommitHistory: [],
      PresentHistory: [],
      B_Option: '',
      dialogInsertData: false,
      tab: null,
      CheckAdmin: false,
      dep_sel: '',
      DepartData: [],
      StaffDataForDep: [],
      dialog: false,
      staff_sel: null,
      TrainHeader: [
        {text: 'วันที่เริ่มต้น', value: 'date_start'},
        {text: 'วันที่สิ้นสุด', value: 'date_end'},
        {text: 'ชื่อโครงการ', value: 'Subject'},
        {text: 'ประเภท', value: 'Type'},
      ],
      CommitHeader: [
        {text: 'วันที่เริ่มต้น', value: 'BegDate'},
        {text: 'วันที่สิ้นสุด', value: 'EndDate'},
        {text: 'รายละเอียด', value: 'Detail'},
      ]
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      committee_Posi: 'Project/getComitteeType',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      TrainData: 'Project/getTrainHisProject',
      CommitData: 'Project/getCommitHisProject',
      PresentData: 'Project/getPresentHisProject',
      boardOption: 'Project/getBoardOption',
      textForPrint: 'Project/getTextForPrint',
      HistoryExpertData: 'Project/getHistoryExpert',
      RegisterProjectData: 'Project/getRegisterProject',
      JournalData: 'Project/getJournal',
      AwardData: 'Project/getAward',
      TrainFilesData: 'Project/getTrainFiles',
      ApproveData: 'Project/getApproveProject',
      LecturerData: 'Project/getLecturer',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      CardData: 'Staff/getCard',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      Competency: 'Competency/getCompetency',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      PermissionAdmin: 'Permission/getPermission',
      MenuPermiss: 'Permission/getMenuPermiss',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      MangeTextForPrint: 'Project/MangeTextForPrint',
      initTrainHistory: 'Project/initTrainHistory',
      initAllTrainHistory: 'Project/initAllTrainHistory',
      initCommitHistory: 'Project/initCommitHistory',
      initAllCommitHistory: 'Project/initAllCommitHistory',
      initPresentHistory: 'Project/initPresentHistory',
      initAllPresentHistory: 'Project/initAllPresentHistory',
      initBoardOption: 'Project/initBoardOption',
      initHistoryExperts: 'Project/initHistoryExperts',
      initAllHistoryExperts: 'Project/initAllHistoryExperts',
      initRegisterProject: 'Project/initRegisterProject',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initJournalProject: 'Project/initJournalProject',
      initAllJournalProject: 'Project/initAllJournalProject',
      initAwardProject: 'Project/initAwardProject',
      initAllAwardProject: 'Project/initAllAwardProject',
      initTrainFilesProject: 'Project/initTrainFilesProject',
      getApproveProjectData: 'Project/getApproveProjectData',
      initLecturerData: 'Project/initLecturerData',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initCardData: 'Staff/initCardData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      getMenuPermissData: 'Permission/getMenuPermissData',
      getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
      changeTypeProject: 'Project/changeTypeProject',
    }),
    init() {
      // this.showDialogInsertData('2')
      this.getApproveProjectData({
        perid: this.MeData[0].perid,
        type: '1'
      }).then(res => {
        if (res) {
          if (this.ApproveData.length > 0) {
            this.CheckApprove = true
          } else {
            this.CheckApprove = false
          }
        }
      }).catch(res => {
        if (res) {
          this.CheckApprove = false
        }
      })
      this.initStaffData().then(res => {
        if (res) {
          this.dumpStaff = []
          if (this.staffData.length > 0) {
            this.staffData.map(item => {
              item.customDetail = item.full_Name + ' (' + item.perid + ')' + ' - ' + item.dep_name
            })
            if (this.DepartData.length > 0) {
              this.DepartData.map(dep_i => {
                this.dumpStaff = this.dumpStaff.concat(this.staffData.filter(staff_i => staff_i.dep_id == dep_i.dep_id))
              })
            }
          }
        }
      })
      this.initComitteeType().then(res => {
        if (res) {
          if (this.committee_Posi.length > 0) {
            // this.CommittType = this.committee_Posi.filter(item => item.committee_type == '1')
            this.CommittType = this.committee_Posi
          }
        }
      })
      this.initlevelData()
      // this.initBoardOption()
    },
    GetOldData(item) {
      var objIem = JSON.parse(JSON.stringify(item))
      this.WorkGroupTypeSubject = objIem.subject
      this.WorkGroupDateS = objIem.date_start
      this.WorkGroupDateE = objIem.date_end
      this.WorkTravelDateS = objIem.date_travel_start
      this.WorkTravelDateE = objIem.date_travel_end
      this.timeSForLecturer = objIem.time_start
      this.timeEForLecturer = objIem.time_end
      this.WorkGroupProjectCode = objIem.Project_code
      this.WorkGroupProjectName = objIem.Project_name
      this.WorkGroupType = objIem.type
      this.FileProject = objIem.files
      this.Rm = objIem.Rm
      this.LecturerProjectName = objIem.Lecturer.Project_name
      this.LecturerHour = objIem.Lecturer.Hour
      this.LecturerInvite = objIem.Lecturer.Invite
      this.LecturerPlace = objIem.Lecturer.Place
      this.LecturerDocNo = objIem.Lecturer.DocNo
      this.LecturerDateDocOut = objIem.Lecturer.DateDocNo
      this.LecturerDateStart = objIem.Lecturer.DateStart
      this.LecturerTimeStart = objIem.Lecturer.TimeStart
      this.LecturerDateEnd = objIem.Lecturer.DateEnd
      this.LecturerTimeEnd = objIem.Lecturer.TimeEnd
    },
    ExportAllData() {
      this.btnLoading = true
      this.json_Export = []
      switch (this.Choice) {
        case "0":
          if (this.dateExStart == '') {
            this.btnLoading = false
            this.$swal.fire({
              icon: 'error',
              title: 'โปรดระบุวันที่เริ่มต้น ที่ใช้ในการดึงข้อมูล'
            })
          } else {
            this.initAllTrainHistory({
              date_start: this.dateExStart,
              date_end: this.dateExEnd,
              type: this.Choice
            }).then(res => {
              if (res) {
                if (this.TrainData[0].TrainOld.length > 0) {
                  this.TrainData[0].TrainOld.map(item => {
                    this.json_Export.push({
                      idx: this.json_Export.length + 1,
                      perid: item.FacID,
                      full_Name: this.staffData.filter(staff => staff.perid == item.FacID).length > 0 ? this.staffData.filter(staff => staff.perid == item.FacID)[0].full_Name : '',
                      Subject: item.Course,
                      Type: item.TypeName,
                      date: item.BegDate == item.EndDate ? (Vue.filter('DateToThai')(item.BegDate)) : (Vue.filter('DateToThai')(item.BegDate)) + ' - ' + (item.EndDate == '0000-00-00' ? 'ไม่กำหนด' : (Vue.filter('DateToThai')(item.EndDate))),
                      date_start: (Vue.filter('DateToThai')(item.BegDate)),
                      date_end: (Vue.filter('DateToThai')(item.EndDate)),
                      Rm: item.DocNo + ' สถานที่: ' + item.Place + ' จัดโดย: ' + item.Holding,
                      files: [],
                      objData: item,
                      Train_Type: 'Train',
                      Condi: true,
                      type_ms: '0'
                    })
                  })
                }

                if (this.TrainData[0].TrainNew.length > 0) {
                  this.TrainData[0].TrainNew.map(item => {
                    switch (item.type) {
                      case '15':
                      case '16':
                      case '17':
                      case '18':
                        if (this.dateExEnd == '') {
                          if (item.date_start >= this.dateExStart) {
                            this.json_Export.unshift({
                              idx: this.json_Export.length + 1,
                              perid: item.perid,
                              full_Name: this.staffData.filter(staff => staff.perid == item.perid).length > 0 ? this.staffData.filter(staff => staff.perid == item.perid)[0].full_Name : '',
                              Subject: item.subject,
                              Type: item.committee_des,
                              date: item.date_start == item.date_end ? (Vue.filter('DateToThai')(item.date_start)) : (Vue.filter('DateToThai')(item.date_start)) + ' - ' + (Vue.filter('DateToThai')(item.date_end)),
                              date_start: (Vue.filter('DateToThai')(item.date_start)),
                              date_end: (Vue.filter('DateToThai')(item.date_end)),
                              Rm: item.Rm,
                              files: [],
                              objData: item,
                              Train_Type: 'Custom',
                              Condi: true,
                              type_ms: '0'
                            })
                          }
                        } else {
                          if (item.date_start >= this.dateExStart && item.date_end <= this.dateExEnd) {
                            this.json_Export.unshift({
                              idx: this.json_Export.length + 1,
                              perid: item.perid,
                              full_Name: this.staffData.filter(staff => staff.perid == item.perid).length > 0 ? this.staffData.filter(staff => staff.perid == item.perid)[0].full_Name : '',
                              Subject: item.subject,
                              Type: item.committee_des,
                              date: item.date_start == item.date_end ? (Vue.filter('DateToThai')(item.date_start)) : (Vue.filter('DateToThai')(item.date_start)) + ' - ' + (Vue.filter('DateToThai')(item.date_end)),
                              date_start: (Vue.filter('DateToThai')(item.date_start)),
                              date_end: (Vue.filter('DateToThai')(item.date_end)),
                              Rm: item.Rm,
                              files: [],
                              objData: item,
                              Train_Type: 'Custom',
                              Condi: true,
                              type_ms: '0'
                            })
                          }
                        }
                        break
                      default:
                        break
                    }
                  })
                }
                this.btnLoading = false
                this.json_Export.sort((a, b) => (a.date_start > b.date_start) ? 1 : ((b.date_start > a.date_start) ? -1 : 0))
                if(this.json_Export.length > 0) {
                  this.json_Export.map((itemEx, idx) => {
                    itemEx.idx = idx + 1
                  })
                }
                this.exportExec = true
              } else {
                this.btnLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาดไม่สามารถ Export ข้อมูลได้'
                })
              }
            }).catch(res => {
              if (res.status) {
                this.btnLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: res.message
                })
              }
            })
          }
          break
        case "1":
          this.initAllCommitHistory({
            date_start: this.dateExStart,
            date_end: this.dateExEnd,
            type: this.Choice
          }).then(res => {
            if (res) {
              if (this.CommitData[0].CommitOld.length > 0) {
                this.CommitData[0].CommitOld.map(item => {
                  this.json_Export.unshift({
                    idx: this.json_Export.length + 1,
                    perid: item.FacID,
                    full_Name: this.staffData.filter(staff => staff.perid == item.FacID).length > 0 ? this.staffData.filter(staff => staff.perid == item.FacID)[0].full_Name : '',
                    Subject: item.Detail,
                    Type: 'กรรมการ',
                    date: item.BegDate == item.EndDate ? (Vue.filter('DateToThai')(item.BegDate)) : (Vue.filter('DateToThai')(item.BegDate)) + ' - ' + (item.EndDate == '0000-00-00' ? 'ไม่กำหนด' : (Vue.filter('DateToThai')(item.EndDate))),
                    date_start: (Vue.filter('DateToThai')(item.BegDate)),
                    date_end: (Vue.filter('DateToThai')(item.EndDate)),
                    Rm: item.DocNo,
                    files: [],
                    objData: item,
                    Train_Type: 'Commit',
                    Condi: false,
                    type_ms: '1'
                  })
                })
              }

              if (this.CommitData[0].CommitNew.length > 0) {
                this.CommitData[0].CommitNew.map(item => {
                  switch (item.type) {
                    case '5':
                    case '10':
                    case '11':
                    case '12':
                    case '19':
                      if (this.dateExEnd == '') {
                        if (item.date_start >= this.dateExStart) {
                          this.json_Export.unshift({
                            idx: this.json_Export.length + 1,
                            perid: item.perid,
                            full_Name: this.staffData.filter(staff => staff.perid == item.perid).length > 0 ? this.staffData.filter(staff => staff.perid == item.perid)[0].full_Name : '',
                            Subject: item.subject,
                            Type: item.committee_des,
                            date: item.date_start == item.date_end ? (Vue.filter('DateToThai')(item.date_start)) : (Vue.filter('DateToThai')(item.date_start)) + ' - ' + (item.date_end == '0000-00-00' ? 'ไม่กำหนด' : (Vue.filter('DateToThai')(item.date_end))),
                            date_start: (Vue.filter('DateToThai')(item.date_start)),
                            date_end: (Vue.filter('DateToThai')(item.date_end)),
                            Rm: item.Rm,
                            files: [],
                            objData: item,
                            Train_Type: 'Custom',
                            Condi: false,
                            type_ms: '1'
                          })
                        }
                      } else {
                        if (item.date_start >= this.dateExStart && item.date_end <= this.dateExEnd) {
                          this.json_Export.unshift({
                            idx: this.json_Export.length + 1,
                            perid: item.perid,
                            full_Name: this.staffData.filter(staff => staff.perid == item.perid).length > 0 ? this.staffData.filter(staff => staff.perid == item.perid)[0].full_Name : '',
                            Subject: item.subject,
                            Type: item.committee_des,
                            date: item.date_start == item.date_end ? (Vue.filter('DateToThai')(item.date_start)) : (Vue.filter('DateToThai')(item.date_start)) + ' - ' + (item.date_end == '0000-00-00' ? 'ไม่กำหนด' : (Vue.filter('DateToThai')(item.date_end))),
                            date_start: (Vue.filter('DateToThai')(item.date_start)),
                            date_end: (Vue.filter('DateToThai')(item.date_end)),
                            Rm: item.Rm,
                            files: [],
                            objData: item,
                            Train_Type: 'Custom',
                            Condi: false,
                            type_ms: '1'
                          })
                        }
                      }
                      break
                    default:
                      break
                  }
                })
              }
              this.btnLoading = false
              this.json_Export.sort((a, b) => (a.date_start > b.date_start) ? 1 : ((b.date_start > a.date_start) ? -1 : 0))
              if(this.json_Export.length > 0) {
                this.json_Export.map((itemEx, idx) => {
                  itemEx.idx = idx + 1
                })
              }
              this.exportExec = true
            } else {
              this.btnLoading = false
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาดไม่สามารถ Export ข้อมูลได้'
              })
            }
          }).catch(res => {
            if (res.status) {
              this.btnLoading = false
              this.$swal.fire({
                icon: 'error',
                title: res.message
              })
            }
          })
          break
        case "2":
          this.initAllPresentHistory({
            date_start: this.dateExStart,
            date_end: this.dateExEnd,
            type: this.Choice
          }).then(res => {
            if (res) {
              if (this.PresentData[0].PresentOld.length > 0) {
                this.PresentData[0].PresentOld.map(item => {
                  this.json_Export.unshift({
                    idx: this.json_Export.length + 1,
                    perid: item.FacID,
                    full_Name: this.staffData.filter(staff => staff.perid == item.FacID).length > 0 ? this.staffData.filter(staff => staff.perid == item.FacID)[0].full_Name : '',
                    Subject: item.Detail,
                    date: item.BegDate == item.EndDate ? (Vue.filter('DateToThai')(item.BegDate)) : (Vue.filter('DateToThai')(item.BegDate)) + ' - ' + (item.EndDate == '0000-00-00' ? 'ไม่กำหนด' : (Vue.filter('DateToThai')(item.EndDate))),
                    Type: item.PresentAction,
                    date_start: (Vue.filter('DateToThai')(item.BegDate)),
                    date_end: (Vue.filter('DateToThai')(item.EndDate)),
                    Rm: item.Detail + ' สถานที่ ' + item.Place + ' ผู้จัด ' + item.Holder,
                    files: [],
                    objData: item,
                    Train_Type: 'Present',
                    Condi: false,
                    type_ms: '1'
                  })
                })
              }

              if (this.PresentData[0].PresentNew.length > 0) {
                this.PresentData[0].PresentNew.map(item => {
                  switch (item.type) {
                    case '6':
                    case '13':
                    case '14':
                    case '23':
                    case '24':
                      if (this.dateExEnd == '') {
                        if (item.date_start >= this.dateExStart) {
                          this.json_Export.unshift({
                            idx: this.json_Export.length + 1,
                            perid: item.perid,
                            full_Name: this.staffData.filter(staff => staff.perid == item.perid).length > 0 ? this.staffData.filter(staff => staff.perid == item.perid)[0].full_Name : '',
                            Subject: item.subject,
                            Type: item.committee_des,
                            date: item.date_start == item.date_end ? (Vue.filter('DateToThai')(item.date_start)) : (Vue.filter('DateToThai')(item.date_start)) + ' - ' + (item.date_end == '0000-00-00' ? 'ไม่กำหนด' : (Vue.filter('DateToThai')(item.date_end))),
                            date_start: (Vue.filter('DateToThai')(item.date_start)),
                            date_end: (Vue.filter('DateToThai')(item.date_end)),
                            Rm: item.Rm,
                            files: [],
                            objData: item,
                            Train_Type: 'Custom',
                            Condi: false,
                            type_ms: '2'
                          })
                        }
                      } else {
                        if (item.date_start >= this.dateExStart && item.date_end <= this.dateExEnd) {
                          this.json_Export.unshift({
                            idx: this.json_Export.length + 1,
                            perid: item.perid,
                            full_Name: this.staffData.filter(staff => staff.perid == item.perid).length > 0 ? this.staffData.filter(staff => staff.perid == item.perid)[0].full_Name : '',
                            Subject: item.subject,
                            Type: item.committee_des,
                            date: item.date_start == item.date_end ? (Vue.filter('DateToThai')(item.date_start)) : (Vue.filter('DateToThai')(item.date_start)) + ' - ' + (item.date_end == '0000-00-00' ? 'ไม่กำหนด' : (Vue.filter('DateToThai')(item.date_end))),
                            date_start: (Vue.filter('DateToThai')(item.date_start)),
                            date_end: (Vue.filter('DateToThai')(item.date_end)),
                            Rm: item.Rm,
                            files: [],
                            objData: item,
                            Train_Type: 'Custom',
                            Condi: false,
                            type_ms: '2'
                          })
                        }
                      }
                      break
                    default:
                      break
                  }
                })
              }
              this.btnLoading = false
              this.json_Export.sort((a, b) => (a.date_start > b.date_start) ? 1 : ((b.date_start > a.date_start) ? -1 : 0))
              if(this.json_Export.length > 0) {
                this.json_Export.map((itemEx, idx) => {
                  itemEx.idx = idx + 1
                })
              }
              this.exportExec = true
            } else {
              this.btnLoading = false
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาดไม่สามารถ Export ข้อมูลได้'
              })
            }
          }).catch(res => {
            if (res.status) {
              this.btnLoading = false
              this.$swal.fire({
                icon: 'error',
                title: res.message
              })
            }
          })
          break
        case "3":
          this.initAllJournalProject().then(res => {
            if (res) {
              if (this.JournalData.length > 0) {
                this.JournalData.map((item, idx) => {
                  this.json_Export.push({
                    ...item,
                    index: idx + 1,
                    Author_Detail: ((item.Author == '0') ? 'ไม่ใช่' : 'ใช่'),
                  })
                })
              }
              this.btnLoading = false
              this.json_Export.sort((a, b) => (a.date_start > b.date_start) ? 1 : ((b.date_start > a.date_start) ? -1 : 0))
              if(this.json_Export.length > 0) {
                this.json_Export.map((itemEx, idx) => {
                  itemEx.idx = idx + 1
                })
              }
              this.exportExec = true
            }
          }).catch(res => {
            if (res) {
              this.btnLoading = false
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาดไม่สามารถ Export ข้อมูลได้'
              })
            }
          })
          break
        default:
          this.initAllAwardProject().then(res => {
            if (res) {
              if (this.AwardData.length > 0) {
                this.AwardData.map((item, idx) => {
                  this.json_Export.push({
                    ...item,
                    index: idx + 1,
                  })
                })
              }
              this.btnLoading = false
              this.json_Export.sort((a, b) => (a.date_start > b.date_start) ? 1 : ((b.date_start > a.date_start) ? -1 : 0))
              if(this.json_Export.length > 0) {
                this.json_Export.map((itemEx, idx) => {
                  itemEx.idx = idx + 1
                })
              }
              this.exportExec = true
            }
          }).catch(res => {
            if (res) {
              this.btnLoading = false
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาดไม่สามารถ Export ข้อมูลได้'
              })
            }
          })
          break
      }
    },
    ExportData() {
      this.json_data = []
      switch (this.tab) {
        case 'tab-2':
          if (this.TrainHistory.length > 0) {
            this.TrainHistory.map((item, idx) => {
              if (item.date_end != '0000-00-00') {
                this.json_data.push({
                  ...item,
                  index: idx + 1,
                  date: (Vue.filter('DateToThai')(item.date_start)) + ' - ' + (Vue.filter('DateToThai')(item.date_end)),
                })
              } else {
                this.json_data.push({
                  ...item,
                  index: idx + 1,
                  date: (Vue.filter('DateToThai')(item.date_start))
                })
              }
            })
            this.json_data.sort((a, b) => (a.date_start > b.date_start) ? 1 : ((b.date_start > a.date_start) ? -1 : 0))
          }
          break
        case 'tab-3':
          if (this.CommitHistory.length > 0) {
            this.CommitHistory.map((item, idx) => {
              if (item.date_end != '0000-00-00') {
                this.json_data.push({
                  ...item,
                  index: idx + 1,
                  date: (Vue.filter('DateToThai')(item.date_start)) + ' - ' + (Vue.filter('DateToThai')(item.date_end)),
                })
              } else {
                this.json_data.push({
                  ...item,
                  index: idx + 1,
                  date: (Vue.filter('DateToThai')(item.date_start))
                })
              }
            })
            this.json_data.sort((a, b) => (a.date_start > b.date_start) ? 1 : ((b.date_start > a.date_start) ? -1 : 0))
          }
          break
        case 'tab-4':
          if (this.PresentHistory.length > 0) {
            this.PresentHistory.map((item, idx) => {
              if (item.date_end != '0000-00-00') {
                this.json_data.push({
                  ...item,
                  index: idx + 1,
                  date: (Vue.filter('DateToThai')(item.date_start)) + ' - ' + (Vue.filter('DateToThai')(item.date_end)),
                })
              } else {
                this.json_data.push({
                  ...item,
                  index: idx + 1,
                  date: (Vue.filter('DateToThai')(item.date_start))
                })
              }
            })
            this.json_data.sort((a, b) => (a.date_start > b.date_start) ? 1 : ((b.date_start > a.date_start) ? -1 : 0))
          }
          break
        case 'tab-5':
          if (this.JournalHistory.length > 0) {
            this.JournalHistory.map((item, idx) => {
              this.json_data.push({
                ...item,
                index: idx + 1,
                Author_Detail: ((item.Author == '0') ? 'ไม่ใช่' : 'ใช่'),
              })
            })
            this.json_data.sort((a, b) => (a.date_start > b.date_start) ? 1 : ((b.date_start > a.date_start) ? -1 : 0))
          }
          break
        case 'tab-6':
          if (this.AwardHistory.length > 0) {
            this.AwardHistory.map((item, idx) => {
              this.json_data.push({
                ...item,
                index: idx + 1,
              })
            })
            this.json_data.sort((a, b) => (a.date_start > b.date_start) ? 1 : ((b.date_start > a.date_start) ? -1 : 0))
          }
          break
        default:
          break
      }
    },
    DelJoinProject(item) {
      this.JoinPerson.map((join_i, idx) => {
        if (join_i.perid == item.perid) {
          this.JoinPerson.splice(idx, 1)
        }
      })
    },
    CheckPermission() {
      return new Promise(resolve => {
        var CheckPermiss = false
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == '8001') {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == '8001') {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
    checkKeyEnter(event) {
      if (event.key == "Enter") {
        this.AddJoinPerson()
      }
    },
    AddJoinPerson() {
      var staff = []
      if (this.staffSelToJoin != '') {
        if (this.staffSelToJoin == this.staff_sel.perid) {
          this.staffSelToJoin = ''
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากรายชื่อที่เลือก เป็นรายชื่อเดียวกันกับที่ทำรายการอยู่่ตอนนี้ !!'
          })
        } else {
          if (this.JoinPerson.length > 0) {
            var CheckDupe = this.JoinPerson.filter(item => item.perid == this.staffSelToJoin)
            if (CheckDupe.length > 0) {
              this.staffSelToJoin = ''
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากพบรายชื่อผู้เข้าร่วมที่เลือกอยู่แล้ว !!!'
              })
            } else {
              staff = this.staffData.filter(item => item.perid == this.staffSelToJoin)
              if (staff.length > 0) {
                this.JoinPerson.push(staff[0])
              }
              this.staffSelToJoin = ''
            }
          } else {
            staff = this.staffData.filter(item => item.perid == this.staffSelToJoin)
            if (staff.length > 0) {
              this.JoinPerson.push(staff[0])
            }
            this.staffSelToJoin = ''
          }
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดเลือกผู้เข้าร่วม'
        })
      }
    },
    RestorePresent() {
      if (this.DumpDataPresent.length > 0) {
        this.PresentHistory = this.DumpDataPresent
      }
    },
    RestoreCommitt() {
      if (this.DumpDataCommittee.length > 0) {
        this.CommitHistory = this.DumpDataCommittee
      }
    },
    RestoreTrain() {
      if (this.DumpDataTrain.length > 0) {
        this.TrainHistory = this.DumpDataTrain
      }
    },
    filterDate(param) {
      switch (param) {
        case '0':
          if (this.DumpDataTrain.length == 0) {
            this.DumpDataTrain = this.TrainHistory
          }
          if (this.searchDateStart != '' && this.searchDateEnd == '') {
            this.TrainHistory = this.DumpDataTrain.filter(item => item.date_start >= this.searchDateStart)
          } else if (this.searchDateStart == '' && this.searchDateEnd != '') {
            this.TrainHistory = this.DumpDataTrain.filter(item => item.date_end <= this.searchDateEnd)
          } else if (this.searchDateStart != '' && this.searchDateEnd != '') {
            this.TrainHistory = this.DumpDataTrain.filter(item => item.date_start >= this.searchDateStart && item.date_end <= this.searchDateEnd)
          }
          break
        case '1':
          if (this.DumpDataCommittee.length == 0) {
            this.DumpDataCommittee = this.CommitHistory
          }
          if (this.searchDateStart != '' && this.searchDateEnd == '') {
            this.CommitHistory = this.DumpDataCommittee.filter(item => item.date_start >= this.searchDateStart)
          } else if (this.searchDateStart == '' && this.searchDateEnd != '') {
            this.CommitHistory = this.DumpDataCommittee.filter(item => item.date_end <= this.searchDateEnd)
          } else if (this.searchDateStart != '' && this.searchDateEnd != '') {
            this.CommitHistory = this.DumpDataCommittee.filter(item => item.date_start >= this.searchDateStart && item.date_end <= this.searchDateEnd)
          }
          break
        case '2':
          if (this.DumpDataPresent.length == 0) {
            this.DumpDataPresent = this.PresentHistory
          }
          if (this.searchDateStart != '' && this.searchDateEnd == '') {
            this.PresentHistory = this.DumpDataPresent.filter(item => item.date_start >= this.searchDateStart)
          } else if (this.searchDateStart == '' && this.searchDateEnd != '') {
            this.PresentHistory = this.DumpDataPresent.filter(item => item.date_end <= this.searchDateEnd)
          } else if (this.searchDateStart != '' && this.searchDateEnd != '') {
            this.PresentHistory = this.DumpDataPresent.filter(item => item.date_start >= this.searchDateStart && item.date_end <= this.searchDateEnd)
          }
          break
        default :
          break
      }
    },
    UniqueArraybyId(collection, keyname) {
      var output = [],
          keys = [];

      collection.map((item) => {
        var key = item[keyname];
        if (keys.indexOf(key) === -1) {
          keys.push(key);
          output.push(item);
        }
      });
      return output;
    },
    SendDataToDb() {
      this.CheckPermission().then(resPermiss => {
        if (resPermiss) {
          if (this.WorkGroup.length > 0) {
            this.$swal.fire({
              title: 'ยืนยันการทำรายการ',
              text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'ตกลง',
              cancelButtonText: 'ยกเลิก'
            }).then((result) => {
              if (result.value) {
                const headerAxios = {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-REST-METHOD': 'PUT'
                  }
                }
                var count = 0
                var CheckUpload = false
                // if (this.WorkGroupType) {
                //
                // } else {
                //
                // }
                if (this.WorkGroup.length > 0) {
                  this.WorkGroup.map(item => {
                    CheckUpload = false
                    if (item.JoinPerson.length > 0) {
                      item.JoinPerson.map(async Join_i => {
                        await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts', {
                          perid: Join_i.perid,
                          Project_code: (this.CheckProjectCode ? item.Project_code : ''),
                          subject: item.subject,
                          type: item.type,
                          date_start: item.date_start,
                          date_end: item.date_end,
                          date_travel_start: item.date_travel_start,
                          date_travel_end: item.date_travel_end,
                          time_start: item.time_start,
                          time_end: item.time_end,
                          Rm: item.Rm,
                          Ref_id: item.Ref_id,
                          type_data: '0',
                          create_by: this.MeData[0].perid,
                          create_time: 'now()',
                          update_by: this.MeData[0].perid,
                        }, headerAxios).then(async res => {
                          if (res.data.status) {
                            if (!CheckUpload) {
                              if (item.files.length > 0) {
                                CheckUpload = true
                                item.files.map(async file => {
                                  await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                                    File_name: file.name,
                                    File_path: file.path,
                                    File_type: file.type,
                                    Ref_id: item.Ref_id,
                                    Create_By: this.MeData[0].perid,
                                    Create_Time: 'now()',
                                  }, headerAxios)
                                })
                              }
                            }
                            if (item.Lecturer != null) {
                              await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Lecturer', {
                                Project_name: item.Lecturer.Project_name,
                                perid: Join_i.perid,
                                Hour: item.Lecturer.Hour,
                                Invite: item.Lecturer.Invite,
                                Place: item.Lecturer.Place,
                                DocNo: item.Lecturer.DocNo,
                                DateDocNo: item.Lecturer.DateDocNo,
                                DateStart: item.Lecturer.DateStart,
                                TimeStart: item.Lecturer.TimeStart,
                                DateEnd: item.Lecturer.DateEnd,
                                TimeEnd: item.Lecturer.TimeEnd,
                                Ref_id: item.Ref_id,
                              }, headerAxios)
                            }
                            if (this.CheckProjectCode) {
                              await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee', {
                                Project_code: item.Project_code,
                                Committee_code: item.type,
                                Perid: item.perid,
                                Name: item.full_Name,
                                Committee_type: '0',
                                TEL: '-',
                                Create_By: this.MeData[0].perid,
                                Create_Time: 'now()',
                              }, headerAxios)
                            }
                          }
                          count++
                          if (count == this.WorkGroup.length) {
                            this.dialogInsertData = false
                            this.WorkGroup = []
                            this.GetDataProfile(this.staff_sel)
                            this.$swal.fire({
                              icon: 'success',
                              title: 'บันทึกข้อมูลสำเร็จ'
                            })
                          }
                        })
                      })
                    } else {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากไม่พบรายชื่อบุคลากรที่ต้องการบันทึกข้อมูล'
                      })
                    }
                  })
                }
              }
            })
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด ไม่พบข้อมูลที่ต้องการบันทึก'
            })
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    UpdateDataToDb() {
      this.CheckPermission().then(resPermiss => {
        if (resPermiss) {
          this.$swal.fire({
            title: 'ยืนยันการทำรายการ',
            text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.value) {
              if (this.EditWorkGroupType != '' && this.EditWorkGroupTypeSubject != ''
                  && this.EditWorkGroupDateS != '') {
                const headerAxios = {
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }
                if (this.EditWorkGroupType == '6' || this.EditWorkGroupType == '13' || this.EditWorkGroupType == '14' || this.EditWorkGroupType == '23' || this.EditWorkGroupType == '24') {
                  if (this.EditLecturerProjectName != '' && this.EditLecturerDocNo != '' && this.EditLecturerInvite != '' && this.EditLecturerHour != '' && this.EditLecturerPlace != ''
                      && this.EditLecturerDateDocOut != '' && this.EditLecturerDateStart != '' && this.EditLecturerTimeStart != '' && this.EditLecturerDateEnd != '' && this.EditLecturerTimeEnd != '') {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/id/' + this.ObjEditData.objData.id, {
                      perid: this.ObjEditData.objData.perid,
                      Project_code: (this.CheckProjectCode ? this.EditWorkGroupProjectCode : ''),
                      subject: this.EditWorkGroupTypeSubject,
                      type: this.EditWorkGroupType,
                      date_start: this.EditWorkGroupDateS,
                      date_end: this.EditWorkGroupDateE,
                      date_travel_start: this.EditWorkTravelDateS,
                      date_travel_end: this.EditWorkTravelDateE,
                      time_start: this.EdittimeSForLecturer,
                      time_end: this.EdittimeEForLecturer,
                      Rm: this.EditRm,
                      Ref_id: this.ObjEditData.objData.Ref_id,
                      update_by: this.MeData[0].perid,
                    }, headerAxios).then(res => {
                      if (res.data.status) {
                        if (this.FileProject.length > 0) {
                          this.FileProject.map(file => {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                              File_name: file.name,
                              File_path: file.path,
                              File_type: file.type,
                              Ref_id: this.ObjEditData.objData.Ref_id,
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }, {
                              headers: {
                                'Content-Type': 'application/json',
                                'X-REST-METHOD': 'PUT'
                              }
                            })
                          })
                        }
                        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Lecturer/Ref_id/' + this.ObjEditData.objData.Ref_id + '/perid/' + this.ObjEditData.objData.perid + '/?limit=1').then(res => {
                          if (res.data) {
                            if (this.EditWorkGroupType == '6' || this.EditWorkGroupType == '13' || this.EditWorkGroupType == '14' || this.EditWorkGroupType == '23' || this.EditWorkGroupType == '24') {
                              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Lecturer/id/' + res.data.id, {
                                Project_name: this.EditLecturerProjectName,
                                perid: this.ObjEditData.objData.perid,
                                Hour: this.EditLecturerHour,
                                Invite: this.EditLecturerInvite,
                                Place: this.EditLecturerPlace,
                                DocNo: this.EditLecturerDocNo,
                                DateDocNo: this.EditLecturerDateDocOut,
                                DateStart: this.EditLecturerDateStart,
                                TimeStart: this.EditLecturerTimeStart,
                                DateEnd: this.EditLecturerDateEnd,
                                TimeEnd: this.EditLecturerTimeEnd,
                                Ref_id: this.ObjEditData.objData.Ref_id,
                              }, headerAxios)
                            }
                          } else {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Lecturer', {
                              Project_name: this.EditLecturerProjectName,
                              perid: this.ObjEditData.objData.perid,
                              Hour: this.EditLecturerHour,
                              Invite: this.EditLecturerInvite,
                              Place: this.EditLecturerPlace,
                              DocNo: this.EditLecturerDocNo,
                              DateDocNo: this.EditLecturerDateDocOut,
                              DateStart: this.EditLecturerDateStart,
                              TimeStart: this.EditLecturerTimeStart,
                              DateEnd: this.EditLecturerDateEnd,
                              TimeEnd: this.EditLecturerTimeEnd,
                              Ref_id: this.ObjEditData.objData.Ref_id,
                            }, {
                              headers: {
                                'Content-Type': 'application/json',
                                'X-REST-METHOD': 'PUT'
                              }
                            })
                          }
                        })

                        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee/Project_code/' + this.EditWorkGroupProjectCode + '/Committee_code/' + this.EditWorkGroupType + '/Perid/' + this.ObjEditData.objData.perid + '/?limit=1').then(resCommit => {
                          if (!resCommit.data) {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee', {
                              Project_code: (this.CheckProjectCode ? this.EditWorkGroupProjectCode : ''),
                              Committee_code: this.EditWorkGroupType,
                              Perid: this.ObjEditData.objData.perid,
                              Name: this.staff_sel.full_Name,
                              Committee_type: '0',
                              Type: '1',
                              TEL: '-',
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }, {
                              headers: {
                                'Content-Type': 'application/json',
                                'X-REST-METHOD': 'PUT'
                              }
                            })
                          }
                        })
                      }
                      this.dialogShowDetail = false
                      this.FileProject = []
                      this.GetDataProfile(this.staff_sel)
                      this.$swal.fire({
                        icon: 'success',
                        title: 'บันทึกข้อมูลสำเร็จ'
                      })
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'โปรดกรอกข้อมูลการเป็นวิทยากรให้ครบถ้วน'
                    })
                  }
                } else {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/id/' + this.ObjEditData.objData.id, {
                    perid: this.ObjEditData.objData.perid,
                    Project_code: (this.CheckProjectCode ? this.EditWorkGroupProjectCode : ''),
                    subject: this.EditWorkGroupTypeSubject,
                    type: this.EditWorkGroupType,
                    date_start: this.EditWorkGroupDateS,
                    date_end: this.EditWorkGroupDateE,
                    date_travel_start: this.EditWorkTravelDateS,
                    date_travel_end: this.EditWorkTravelDateE,
                    time_start: this.EdittimeSForLecturer,
                    time_end: this.EdittimeEForLecturer,
                    Rm: this.EditRm,
                    Ref_id: this.ObjEditData.objData.Ref_id,
                    update_by: this.MeData[0].perid,
                  }, headerAxios).then(res => {
                    if (res.data.status) {
                      if (this.FileProject.length > 0) {
                        this.FileProject.map(file => {
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                            File_name: file.name,
                            File_path: file.path,
                            File_type: file.type,
                            Ref_id: this.ObjEditData.objData.Ref_id,
                            Create_By: this.MeData[0].perid,
                            Create_Time: 'now()',
                          }, {
                            headers: {
                              'Content-Type': 'application/json',
                              'X-REST-METHOD': 'PUT'
                            }
                          })
                        })
                      }

                      if (this.CheckProjectCode) {
                        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee/Project_code/' + this.EditWorkGroupProjectCode + '/Committee_code/' + this.EditWorkGroupType + '/Perid/' + this.ObjEditData.objData.perid + '/?limit=1').then(resCommit => {
                          if (!resCommit.data) {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee', {
                              Project_code: this.EditWorkGroupProjectCode,
                              Committee_code: this.EditWorkGroupType,
                              Perid: this.ObjEditData.objData.perid,
                              Name: this.staff_sel.full_Name,
                              Committee_type: '0',
                              Type: '1',
                              TEL: '-',
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }, {
                              headers: {
                                'Content-Type': 'application/json',
                                'X-REST-METHOD': 'PUT'
                              }
                            })
                          }
                        })
                      } else {
                        if (this.ObjEditData != null && this.ObjEditData.objData != null && (this.ObjEditData.objData.Project_code != '' && this.ObjEditData.objData.Project_code != null)) {
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee/Project_code/' + this.ObjEditData.objData.Project_code + '/Committee_code/' + this.EditWorkGroupType + '/Perid/' + this.ObjEditData.objData.perid, {
                            active: '0',
                            Update_By: this.MeData[0].perid
                          }, {
                            headers: {
                              'Content-Type': 'application/json',
                            }
                          })
                        }
                      }
                    }
                    this.dialogShowDetail = false
                    this.FileProject = []
                    this.files = []
                    this.GetDataProfile(this.staff_sel)
                    this.$swal.fire({
                      icon: 'success',
                      title: 'บันทึกข้อมูลสำเร็จ'
                    })
                  })
                }
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'กรุณาระบุข้อมูลตามช่องสีแดงให้ครบถ้วน'
                })
              }
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    OpenDialogAward() {
      this.dialogInsertAward = true
      this.AwYear = ''
      this.AwBy = ''
      this.AwName = ''
      this.AwDetail = ''
      this.AwDoc = ''
      this.Rm = ''
      this.FileProject = []
      this.files = []
      this.FileToShow = []
      this.AwardDump = []
      this.JoinPerson = []
      var staff = this.staffData.filter(item => item.perid == this.staff_sel.perid)
      if (staff.length > 0) {
        this.JoinPerson.push(staff[0])
      }
    },
    OpenDialogJournal() {
      this.dialogInsertJournal = true
      this.YearPrint = ''
      this.Journal = ''
      this.Rm = ''
      this.MainName = 'False'
      this.files = []
      this.FileProject = []
      this.JournalDump = []
      this.JoinPerson = []
      var staff = this.staffData.filter(item => item.perid == this.staff_sel.perid)
      if (staff.length > 0) {
        this.JoinPerson.push(staff[0])
      }
    },
    EditAward(param) {
      this.AwYear = ''
      this.AwBy = ''
      this.AwName = ''
      this.AwDetail = ''
      this.AwDoc = ''
      this.Rm = ''
      this.FileProject = []
      this.files = []
      this.FileToShow = []
      this.ObjEditData = null

      this.dialogEditAward = true
      this.ObjEditData = param
      // this.ObjEditData.objData.Ref_id = ((this.ObjEditData.objData.Ref_id == null || this.ObjEditData.objData.Ref_id == '') ? this.getRandomFileName() : this.ObjEditData.objData.Ref_id)
      this.AwYear = param.AwYear
      this.AwName = param.AwName
      this.AwBy = param.AwBy
      this.AwDetail = param.AwDetail
      this.AwDoc = param.AwDoc
      this.Rm = param.Rm
      this.initTrainFilesProject({
        Ref_id: param.Ref_id
      }).then(res => {
        if (res) {
          this.FileToShow = this.TrainFilesData
        }
      }).catch(resErr => {
        if (resErr) {
          this.FileToShow = []
        }
      })
    },
    EditJournal(param) {
      this.YearPrint = ''
      this.Journal = ''
      this.Rm = ''
      this.MainName = 'False'
      this.files = []
      this.FileProject = []
      this.FileToShow = []
      this.ObjEditData = null

      this.dialogEditJournal = true
      this.ObjEditData = param
      // this.ObjEditData.objData.Ref_id = ((this.ObjEditData.objData.Ref_id == null || this.ObjEditData.objData.Ref_id == '') ? this.getRandomFileName() : this.ObjEditData.objData.Ref_id)
      this.YearPrint = param.YearPrint
      this.Journal = param.Journal
      this.Rm = param.Rm
      this.MainName = param.Author
      this.initTrainFilesProject({
        Ref_id: param.Ref_id
      }).then(res => {
        if (res) {
          this.FileToShow = this.TrainFilesData
        }
      }).catch(resErr => {
        if (resErr) {
          this.FileToShow = []
        }
      })
    },
    DeleteTrainItemOld(item) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "ต้องการลบ " + item.Type + ' หัวข้อ ' + item.Subject + ' ใช่หรือไม่ ??',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          const headerAxios = {
            headers: {
              'Content-Type': 'application/json',
            }
          }
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/id/' + item.objData.id, {
            active: '0',
            update_by: this.MeData[0].perid,
          }, headerAxios).then(res => {
            if (res.data.status) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Appointment_Team/Ref_id/' + item.objData.Ref_id + '/perid/' + item.objData.perid, {
                active: '0',
                update_by: this.MeData[0].perid,
              }, headerAxios)
              this.$swal.fire({
                icon: 'success',
                title: 'ลบข้อมูลสำเร็จ'
              })
              if (item.objData.type == '6' || item.objData.type == '13' || item.objData.type == '14' || item.objData.type == '23' || item.objData.type == '24') {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Lecturer/Ref_id/' + item.objData.Ref_id + '/perid/' + item.objData.perid, {
                  active: '0',
                  Create_By: this.MeData[0].perid
                }, headerAxios)
              }
              this.dialogShowDetail = false
              this.GetDataProfile(this.staff_sel)
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถลบข้อมูลได้'
              })
            }
          })
        } else {
          this.dialogShowDetail = false
        }
      })
    },
    DeleteItemData(item) {
      var txtAlert = ''
      switch (item.type_ms) {
        case "0":
          txtAlert = 'ข้อมูลการ อบรม / ประชุม / ศึกษา / ดูงาน'
          break
        case "1":
          txtAlert = 'ข้อมูลคณะกรรมการ'
          break
        case "2":
          txtAlert = 'ข้อมูลวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน'
          break
        default:
          break
      }
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "ต้องการลบ " + txtAlert + ' หัวข้อ ' + item.Subject + ' ใช่หรือไม่ ??',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          const headerAxios = {
            headers: {
              'Content-Type': 'application/json',
            }
          }
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/id/' + item.objData.id, {
            active: '0',
            update_by: this.MeData[0].perid,
          }, headerAxios).then(res => {
            if (res.data.status) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Appointment_Team/Ref_id/' + item.objData.Ref_id + '/perid/' + item.objData.perid, {
                active: '0',
                update_by: this.MeData[0].perid,
              }, headerAxios)
              this.$swal.fire({
                icon: 'success',
                title: 'ลบข้อมูลสำเร็จ'
              })
              if (item.objData.type == '6' || item.objData.type == '13' || item.objData.type == '14' || item.objData.type == '23' || item.objData.type == '24') {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Lecturer/Ref_id/' + item.objData.Ref_id + '/perid/' + item.objData.perid, {
                  active: '0',
                  Create_By: this.MeData[0].perid
                }, headerAxios)
              }
              this.dialogShowDetail = false
              this.GetDataProfile(this.staff_sel)
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถลบข้อมูลได้'
              })
            }
          })
        } else {
          this.dialogShowDetail = false
        }
      })
    },
    DeleteItemData2(item) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: 'ต้องการลบ บทความ หัวข้อ ' + item.Journal + ' ใช่หรือไม่ ??',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          const headerAxios = {
            headers: {
              'Content-Type': 'application/json',
            }
          }
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/viewextdb/Journal/RefID/' + item.RefID, {
            active: '0',
            Create_By: this.MeData[0].perid
          }, headerAxios).then(res => {
            if (res.data.status) {
              this.$swal.fire({
                icon: 'success',
                title: 'ลบข้อมูลสำเร็จ'
              })
              this.dialogEditJournal = false
              this.GetDataProfile(this.staff_sel)
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถลบข้อมูลได้'
              })
            }
          })
        } else {
          this.dialogEditJournal = false
        }
      })
    },
    DeleteItemData3(item) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: 'ต้องการลบ รางวัลพิเศษ หัวข้อ ' + item.AwName + ' ใช่หรือไม่ ??',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          const headerAxios = {
            headers: {
              'Content-Type': 'application/json',
            }
          }
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/viewextdb/Award/RefID/' + item.RefID, {
            active: '0',
            Create_By: this.MeData[0].perid
          }, headerAxios).then(res => {
            if (res.data.status) {
              this.$swal.fire({
                icon: 'success',
                title: 'ลบข้อมูลสำเร็จ'
              })
              this.dialogEditAward = false
              this.GetDataProfile(this.staff_sel)
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถลบข้อมูลได้'
              })
            }
          })
        } else {
          this.dialogEditAward = false
        }
      })
    },
    GetExpanded(expanFunc, expan) {
      console.log(expanFunc)
      console.log(expan)
    },
    ShowDetailCommit(rows) {
      console.log(rows)
      // axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.WorkGroupProjectCode + '/?limit=1').then(res => {
      //   if (res.data) {
      //     this.CheckProjectCode = true
      //     this.WorkGroupProjectName = res.data.Project_name
      //   } else {
      //     this.CheckProjectCode = false
      //     this.WorkGroupProjectName = ''
      //   }
      // }, err => {
      //   console.log(err)
      // })
    },
    EditJournalData() {
      this.CheckPermission().then(resPermiss => {
        if (resPermiss) {
          this.$swal.fire({
            title: 'ยืนยันการทำรายการ',
            text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.value) {
              const headerAxios = {
                headers: {
                  'Content-Type': 'application/json'
                }
              }

              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/viewextdb/Journal/RefID/' + this.ObjEditData.RefID, {
                YearPrint: this.YearPrint,
                Journal: this.Journal,
                Author: this.MainName,
                Rm: this.Rm,
                FacID: this.ObjEditData.FacID,
                update_by: this.MeData[0].perid,
              }, headerAxios).then(res => {
                if (res.data.status) {
                  if (this.FileProject.length > 0) {
                    this.FileProject.map(file => {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                        File_name: file.name,
                        File_path: file.path,
                        File_type: file.type,
                        Ref_id: this.ObjEditData.Ref_id,
                        Create_By: this.MeData[0].perid,
                        Create_Time: 'now()',
                      }, {
                        headers: {
                          'Content-Type': 'application/json',
                          'X-REST-METHOD': 'PUT'
                        }
                      })
                    })
                  }
                }

                this.dialogEditJournal = false
                this.GetDataProfile(this.staff_sel)
                this.$swal.fire({
                  icon: 'success',
                  title: 'บันทึกข้อมูลสำเร็จ'
                })
              })
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    AddJournalDump() {
      if (this.YearPrint != '' && this.Journal != ''
          && this.MainName != null) {
        this.JournalDump.push({
          id: this.JournalDump.length + 1,
          YearPrint: this.YearPrint,
          Journal: this.Journal,
          MainName: this.MainName,
          Rm: this.Rm,
          perid: this.staff_sel.perid,
          files: this.FileProject,
          JoinPerson: this.JoinPerson,
        })
        this.Journal = ''
        this.Rm = ''
        this.MainName = 'False'
        this.YearPrint = ''
        this.FileProject = []
        this.files = []
        this.JoinPerson = []
        var staff = this.staffData.filter(item => item.perid == this.staff_sel.perid)
        if (staff.length > 0) {
          this.JoinPerson.push(staff[0])
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุข้อมูลให้ครบถ้วน'
        })
      }
    },
    AddJournalData() {
      this.CheckPermission().then(resPermiss => {
        if (resPermiss) {
          if (this.JournalDump.length > 0) {
            this.$swal.fire({
              title: 'ยืนยันการทำรายการ',
              text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'ตกลง',
              cancelButtonText: 'ยกเลิก'
            }).then((result) => {
              if (result.value) {
                const headerAxios = {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-REST-METHOD': 'PUT'
                  }
                }
                var count = 0
                var Ref_id = ''
                var CheckUpload = false
                if (this.JournalDump.length > 0) {
                  this.JournalDump.map(item => {
                    CheckUpload = false
                    Ref_id = this.getRandomFileName()
                    if (item.JoinPerson.length > 0) {
                      item.JoinPerson.map(async Join_i => {
                        await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/viewextdb/Journal', {
                          YearPrint: item.YearPrint,
                          Journal: item.Journal,
                          Author: item.MainName,
                          Rm: item.Rm,
                          FacID: Join_i.perid,
                          Ref_id: Ref_id,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()',
                          update_by: this.MeData[0].perid,
                        }, headerAxios).then(res => {
                          if (res.data.status) {
                            if (!CheckUpload) {
                              if (item.files.length > 0) {
                                CheckUpload = true
                                item.files.map(file => {
                                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                                    File_name: file.name,
                                    File_path: file.path,
                                    File_type: file.type,
                                    Ref_id: Ref_id,
                                    Create_By: this.MeData[0].perid,
                                    Create_Time: 'now()',
                                  }, headerAxios)
                                })
                              }
                            }
                          }
                          count++
                          if (count == this.JournalDump.length) {
                            this.dialogInsertJournal = false
                            this.JournalDump = []
                            this.GetDataProfile(this.staff_sel)
                            this.$swal.fire({
                              icon: 'success',
                              title: 'บันทึกข้อมูลสำเร็จ'
                            })
                          }
                        })
                      })
                    } else {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากไม่พบรายชื่อบุคลากรที่ต้องการบันทึกข้อมูล'
                      })
                    }
                  })
                }
              }
            })
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด ไม่พบข้อมูลที่ต้องการบันทึก'
            })
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    AddAwardDump() {
      if (this.AwYear != '' && this.AwName != '') {
        this.AwardDump.push({
          id: this.AwardDump.length + 1,
          AwYear: this.AwYear,
          AwName: this.AwName,
          AwBy: this.AwBy,
          AwDetail: this.AwDetail,
          AwDoc: this.AwDoc,
          Rm: this.Rm,
          perid: this.staff_sel.perid,
          files: this.FileProject,
          JoinPerson: this.JoinPerson,
        })
        this.AwYear = ''
        this.AwBy = ''
        this.AwName = ''
        this.AwDetail = ''
        this.AwDoc = ''
        this.Rm = ''
        this.FileProject = []
        this.files = []
        this.JoinPerson = []
        var staff = this.staffData.filter(item => item.perid == this.staff_sel.perid)
        if (staff.length > 0) {
          this.JoinPerson.push(staff[0])
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุข้อมูล ปี พ.ศ. , ชื่อรางวัล ให้ครบถ้วน'
        })
      }
    },
    EditAwardData() {
      this.CheckPermission().then(resPermiss => {
        if (resPermiss) {
          this.$swal.fire({
            title: 'ยืนยันการทำรายการ',
            text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.value) {
              if (this.AwYear != '' && this.AwName != '') {
                const headerAxios = {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-REST-METHOD': 'PUT'
                  }
                }
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/viewextdb/Award/RefID/' + this.ObjEditData.RefID, {
                  AwYear: this.AwYear,
                  AwBy: this.AwBy,
                  AwName: this.AwName,
                  AwDetail: this.AwDetail,
                  AwDoc: this.AwDoc,
                  FacID: this.ObjEditData.FacID,
                  Rm: this.Rm,
                  update_by: this.MeData[0].perid,
                }, {
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }).then(res => {
                  if (res.data.status) {
                    if (this.FileProject.length > 0) {
                      this.FileProject.map(file => {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                          File_name: file.name,
                          File_path: file.path,
                          File_type: file.type,
                          Ref_id: this.ObjEditData.Ref_id,
                          Create_By: this.MeData[0].perid,
                          Create_Time: 'now()',
                        }, headerAxios)
                      })
                    }
                  }
                  this.dialogEditAward = false
                  this.GetDataProfile(this.staff_sel)
                  this.$swal.fire({
                    icon: 'success',
                    title: 'บันทึกข้อมูลสำเร็จ'
                  })
                })
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'กรุณาระบุข้อมูล ปี พ.ศ. , ชื่อรางวัล ให้ครบถ้วน'
                })
              }
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    AddAwardData() {
      this.CheckPermission().then(resPermiss => {
        if (resPermiss) {
          if (this.AwardDump.length > 0) {
            this.$swal.fire({
              title: 'ยืนยันการทำรายการ',
              text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'ตกลง',
              cancelButtonText: 'ยกเลิก'
            }).then((result) => {
              if (result.value) {
                const headerAxios = {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-REST-METHOD': 'PUT'
                  }
                }
                var count = 0
                var Ref_id = ''
                var CheckUpload = false
                if (this.AwardDump.length > 0) {
                  this.AwardDump.map(item => {
                    CheckUpload = false
                    Ref_id = this.getRandomFileName()
                    if (item.JoinPerson.length > 0) {
                      item.JoinPerson.map(async Join_i => {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/viewextdb/Award', {
                          AwYear: item.AwYear,
                          AwBy: item.AwBy,
                          AwName: item.AwName,
                          AwDetail: item.AwDetail,
                          AwDoc: item.AwDoc,
                          FacID: Join_i.perid,
                          Rm: item.Rm,
                          Ref_id: Ref_id,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()',
                          update_by: this.MeData[0].perid,
                        }, headerAxios).then(res => {
                          if (res.data.status) {
                            if (!CheckUpload) {
                              if (item.files.length > 0) {
                                CheckUpload = true
                                item.files.map(file => {
                                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                                    File_name: file.name,
                                    File_path: file.path,
                                    File_type: file.type,
                                    Ref_id: Ref_id,
                                    Create_By: this.MeData[0].perid,
                                    Create_Time: 'now()',
                                  }, headerAxios)
                                })
                              }
                            }
                          }
                          count++
                          if (count == this.AwardDump.length) {
                            this.dialogInsertAward = false
                            this.AwardDump = []
                            this.GetDataProfile(this.staff_sel)
                            this.$swal.fire({
                              icon: 'success',
                              title: 'บันทึกข้อมูลสำเร็จ'
                            })
                          }
                        })
                      })
                    } else {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากไม่พบรายชื่อบุคลากรที่ต้องการบันทึกข้อมูล'
                      })
                    }
                  })
                }
              }
            })
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด ไม่พบข้อมูลที่ต้องการบันทึก'
            })
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    getRandomFileName() {
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      return random_number;
    },
    showDialogInsertData(type) {
      // this.WorkGroup = []
      this.WorkGroupType = ''
      this.WorkGroupTypeSubject = ''
      this.WorkGroupProjectCode = ''
      this.WorkGroupProjectName = ''
      this.WorkGroupDateS = ''
      this.WorkGroupDateE = ''
      this.timeSForLecturer = ''
      this.timeEForLecturer = ''
      this.files = []
      this.FileProject = []
      this.WorkGroup = []
      this.dumpCommitData = []
      this.JoinPerson = []
      this.TypeEdit = ''
      this.TypeEdit = type

      var staff = this.staffData.filter(item => item.perid == this.staff_sel.perid)
      if (staff.length > 0) {
        this.JoinPerson.push(staff[0])
      }

      if (type == '0') {
        this.Subject = 'บันทึกข้อมูลการ อบรม / ประชุม / ศึกษา / ดูงาน'
        this.dumpCommitData = this.CommittType.filter(item => item.Committee_code == '15' || item.Committee_code == '16'
            || item.Committee_code == '17' || item.Committee_code == '18')
      } else if (type == '1') {
        this.Subject = 'บันทึกข้อมูลคณะกรรมการ'
        this.dumpCommitData = this.CommittType.filter(item => item.Committee_code == '5' || item.Committee_code == '10'
            || item.Committee_code == '11' || item.Committee_code == '12' || item.Committee_code == '19')
      } else if (type == '2') {
        this.Subject = 'บันทึกข้อมูลวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน'
        this.dumpCommitData = this.CommittType.filter(item => item.Committee_code == '6' || item.Committee_code == '13'
            || item.Committee_code == '14' || item.Committee_code == '23' || item.Committee_code == '24')
      } else {
        this.dumpCommitData = this.CommittType
      }
      this.dialogInsertData = true
    },
    ShowData: function (dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );

    },
    Del_file(file, idx) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการลบไฟล์ " + file.File_name + ' ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          const headerAxiosDel = {
            headers: {
              'Content-Type': 'application/json',
            }
          }
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/id/' + file.id, {
            active: '0',
            Create_By: this.MeData[0].perid
          }, headerAxiosDel).then(res => {
            if (res.data.status) {
              this.FileToShow.splice(idx, 1)
              this.$swal.fire({
                icon: 'success',
                title: 'ลบไฟล์ ' + file.File_name + ' สำเร็จ !!'
              })
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาดไม่สามารถลบข้อมูลไฟล์ได้'
              })
            }
          })
        }
      })
    },
    DeleteFile(file_i) {
      const headerAxiosDel = {
        headers: {
          'Content-Type': 'application/json',
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/id/' + file_i.id, {
        active: '0',
        Update_By: this.MeData[0].perid
      }, headerAxiosDel).then(res => {
        if (res.data.status) {
          if (this.FileProject.length > 0) {
            this.FileProject.map((item, idx) => {
              if (item.name == file_i.name) {
                this.FileProject.splice(idx, 1)
              }
            })
          }
        }
      })
    },
    DeleteFile2(file_i) {
      this.FileProject.map((item, idx) => {
        if (item.name == file_i.name) {
          this.FileProject.splice(idx, 1)
        }
      })
    },
    FileSelect: function () {
      // var count = 0
      this.txtAlert = []
      this.FileProject = []
      this.alert = false
      if (this.files.length > 0) {
        this.files.map((item) => {
          var Checkfile = false;
          switch (item.type) {
            case 'image/jpg':
            case 'image/jpeg':
            case 'image/gif':
            case 'image/bmp':
            case 'image/png':
              Checkfile = true;
              break
            case 'application/pdf':
              Checkfile = true;
              break
            default:
              Checkfile = false;
              break
          }

          if (Checkfile) {
            if (item.size > 2048 * 2048) {
              this.txtAlert.push({
                id: this.txtAlert.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 4 mb*'
              })
            }
          } else {
            this.txtAlert.push({
              id: this.txtAlert.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type.split('/')[1] + ' ( ' + item.name + ' ) '
            })
          }
        })
      }

      if (this.txtAlert.length == 0) {
        this.files.map((item) => {
          const fd = new FormData()
          fd.append('file', item, item.name)
          const headerAxios = {
            headers: {
              'Content-Type': 'multipart/form-data',
              'WithCredentials': true,
              "Access-Control-Allow-Origin": "*"
              // "Accept": 'multipart/form-data'
            }
          }

          axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
            if (res.data.status) {
              switch (item.type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.FileProject.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'image',
                    type_Img: item.type
                  })
                  break
                case 'application/pdf':
                  this.FileProject.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'pdf',
                    type_Img: item.type
                  })
                  break
                default:
                  break
              }

              // count++
              //
              // if (count === this.files.length) {
              //     this.FileProjectPdf = []
              //     this.FileProject = []
              // }
            }
          })
        })

      } else {
        this.alert = true
      }

    },
    CheckProject() {
      if (this.WorkGroupProjectCode != '') {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.WorkGroupProjectCode + '/?limit=1').then(res => {
          if (res.data) {
            this.CheckProjectCode = true
            this.WorkGroupProjectName = res.data.Project_name
          } else {
            this.CheckProjectCode = false
            this.WorkGroupProjectName = ''
          }
        }, err => {
          console.log(err)
        })
      }
    },
    CheckProject2() {
      if (this.EditWorkGroupProjectCode != '') {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.EditWorkGroupProjectCode + '/?limit=1').then(res => {
          if (res.data) {
            this.CheckProjectCode = true
            this.EditWorkGroupProjectName = res.data.Project_name
          } else {
            this.CheckProjectCode = false
            this.EditWorkGroupProjectName = ''
          }
        }, err => {
          console.log(err)
        })
      }
    },
    CheckStaffSelClear() {
      this.staff_sel_choose = ''
      this.SelDepFunc()
    },
    SelStaffFunc() {
      if (this.staff_sel_choose != '') {
        if (this.dumpStaff.filter(item => item.perid == this.staff_sel_choose).length > 0) {
          this.dep_sel = this.dumpStaff.filter(item => item.perid == this.staff_sel_choose)[0].dep_id
          this.SelDepFunc(false)
          this.StaffDataForDep = this.StaffDataForDep.filter(item => item.perid == this.staff_sel_choose)
        }
      }
    },
    SelDepFunc(param) {
      this.StaffDataForDep = this.staffData.filter(item => item.dep_id == this.dep_sel)
      if (param) {
        this.CheckStaffSelClear()
      }
      // this.CheckStaffSelClear()
    },
    GetDataProfile(params) {
      this.staff_sel = null
      this.staff_sel = params
      this.TrainHistory = []
      this.CommitHistory = []
      this.PresentHistory = []
      this.JournalHistory = []
      this.JournalHistory = []
      this.AwardHistory = []
      this.DumpDataTrain = []
      this.DumpDataCommittee = []
      this.DumpDataPresent = []
      this.initTrainHistory({
        perid: params.perid
      }).then(res => {
        if (res) {
          this.TrainData.map(item => {
            this.TrainHistory.push({
              idx: this.TrainHistory.length + 1,
              Subject: item.Course,
              Type: item.TypeName,
              date_start: item.BegDate,
              date_end: item.EndDate,
              Rm: item.DocNo + ' สถานที่: ' + item.Place + ' จัดโดย: ' + item.Holding,
              files: [],
              objData: item,
              Train_Type: 'Train',
              Condi: true,
              type_ms: '0'
            })
          })
        }

        /*this.initRegisterProject({
          perid: params.perid
        }).then(res => {
          if (res) {
            this.RegisterProjectData.map(item => {
              this.TrainHistory.unshift({
                idx: this.TrainHistory.length + 1,
                Subject: item.Project_name,
                Type: item.Project_group_des,
                date_start: item.DateStart,
                date_end: item.DateEnd,
                Rm: ' สถานที่: ' + item.Location + ' จัดโดย: ' + item.WorkByName,
                files: [],
                objData: item,
                Train_Type: 'Regis',
                Condi: true,
                type_ms: '0'
              })
            })
          }
        })*/
      })

      this.initHistoryExperts({
        perid: params.perid
      }).then(resExpert => {
        if (resExpert) {
          // this.HistoryExpertData.map(item => {
          //   this.TrainHistory.unshift({
          //     Subject: item.subject,
          //     Type: item.committee_des,
          //     date_start: item.date_travel_start,
          //     date_end: item.date_travel_end,
          //   })
          // })


          this.HistoryExpertData.map(item => {
            switch (item.type) {
              case '15':
                this.TrainHistory.unshift({
                  idx: this.TrainHistory.length + 1,
                  Subject: item.subject,
                  Type: item.committee_des,
                  date_start: item.date_start,
                  date_end: item.date_end,
                  Rm: (item.Rm == null ? "" : item.Rm ) + ' สถานที่: ' + (item.Place == null ? "-" : item.Place ) + ' จัดโดย: ' + (item.dep_name == null ? "-" : item.dep_name ),
                  files: [],
                  objData: item,
                  Train_Type: 'Custom',
                  Condi: true,
                  type_ms: '0'
                })
                break
              case '16':
              case '17':
              case '18':
                this.TrainHistory.unshift({
                  idx: this.TrainHistory.length + 1,
                  Subject: item.subject,
                  Type: item.committee_des,
                  date_start: item.date_start,
                  date_end: item.date_end,
                  Rm: (item.Rm == null ? "" : item.Rm ) + ' สถานที่: ' + (item.Location == null ? "-" : item.Location ) + ' จัดโดย: ' + (item.WorkByName == null ? "-" : item.WorkByName ),
                  files: [],
                  objData: item,
                  Train_Type: 'Custom',
                  Condi: true,
                  type_ms: '0'
                })
                break
              default:
                break
            }
          })


          this.initCommitHistory({
            perid: params.perid
          }).then(res => {
            if (res) {
              if (this.CommitData.length > 0) {
                this.CommitData.map(item => {
                  this.CommitHistory.unshift({
                    id: '',
                    idx: this.CommitHistory.length,
                    Subject: item.Detail,
                    Type: 'กรรมการ',
                    date_start: item.BegDate,
                    date_end: item.EndDate,
                    Rm: item.DocNo,
                    files: [],
                    objData: item,
                    Train_Type: 'Commit',
                    Condi: false,
                    type_ms: '1'
                  })
                })
              }

              this.HistoryExpertData.map(item => {
                switch (item.type) {
                  case '1':
                  case '2':
                  case '3':
                  case '4':
                  case '5':
                  case '10':
                  case '11':
                  case '12':
                  case '19':
                  case '20':
                  case '21':
                  case '22':
                    this.CommitHistory.unshift({
                      id: item.id,
                      idx: this.CommitHistory.length,
                      Subject: item.subject,
                      Type: item.committee_des,
                      date_start: item.date_start,
                      date_end: item.date_end,
                      Rm: item.Rm,
                      files: [],
                      objData: item,
                      Train_Type: 'Custom',
                      Condi: false,
                      type_ms: '1'
                    })
                    break
                  default:
                    break
                }
              })
            }
          }).catch(res => {
            if (res) {
              this.HistoryExpertData.map(item => {
                switch (item.type) {
                  case '1':
                  case '2':
                  case '3':
                  case '4':
                  case '5':
                  case '10':
                  case '11':
                  case '12':
                  case '19':
                  case '20':
                  case '21':
                  case '22':
                    this.CommitHistory.unshift({
                      id: item.id,
                      idx: this.CommitHistory.length,
                      Subject: item.subject,
                      Type: item.committee_des,
                      date_start: item.date_start,
                      date_end: item.date_end,
                      Rm: item.Rm,
                      files: [],
                      objData: item,
                      Train_Type: 'Custom',
                      Condi: false,
                      type_ms: '1'
                    })
                    break
                  default:
                    break
                }
              })
            }
          })

          this.initPresentHistory({
            perid: params.perid
          }).then(res => {
            if (res) {
              if (this.PresentData.length > 0) {
                this.PresentData.map(item => {
                  this.PresentHistory.unshift({
                    id: '',
                    idx: this.PresentHistory.length,
                    Subject: item.Topic,
                    Type: item.PresentAction,
                    date_start: item.BegDate,
                    date_end: item.EndDate,
                    Rm: ': ' + item.Detail + ' สถานที่ ' + item.Place + ' ผู้จัด ' + item.Holder,
                    files: [],
                    objData: item,
                    Train_Type: 'Present',
                    Condi: false,
                    type_ms: '2'
                  })
                })
              }

              this.HistoryExpertData.map(item => {
                switch (item.type) {
                  case '6':
                  case '13':
                  case '14':
                  case '23':
                  case '24':
                    this.initLecturerData({
                      Ref_id: item.Ref_id,
                      perid: params.perid
                    }).then(res => {
                      if (res) {
                        this.PresentHistory.unshift({
                          id: item.id,
                          idx: this.PresentHistory.length,
                          Subject: item.subject,
                          Type: item.committee_des,
                          date_start: item.date_start,
                          date_end: item.date_end,
                          Rm: item.Rm,
                          files: [],
                          objData: {
                            ...item,
                            Lecturer: this.LecturerData.length > 0 ? this.LecturerData[0] : null,
                            CustomDetail: this.LecturerData.length > 0 ? '<div>' +
                                '<div>โครงการ ' + this.LecturerData[0].Project_name + '</div>' +
                                '<div>ผู้เชิญ ' + this.LecturerData[0].Invite + ' จำนวน ' + this.LecturerData[0].Hour + ' ช.ม.  ช่วงที่เป็นวิทยากร ' + (this.LecturerData[0].DateStart == '0000-00-00' ? ' - ' : Vue.filter('DateToThai')(this.LecturerData[0].DateStart)) + ' - ' + (this.LecturerData[0].DateEnd == '0000-00-00' ? ' - ' : Vue.filter('DateToThai')(this.LecturerData[0].DateEnd)) + ' เวลา ' + this.LecturerData[0].TimeStart + ' น. - ' + this.LecturerData[0].TimeEnd + ' น.</div>' +
                                '<div>สถานที่ ' + this.LecturerData[0].Place + '</div>' +
                                '<div>เลขที่หนังสือ ' + this.LecturerData[0].DocNo + ' วันที่ออกหนัสือ ' + (this.LecturerData[0].DateDocNo == '0000-00-00' ? ' - ' : Vue.filter('DateToThai')(this.LecturerData[0].DateDocNo)) + '</div>' +
                                '</div>' : '',
                          },
                          Train_Type: 'Custom',
                          Condi: false,
                          type_ms: '2',
                        })
                      }
                    }).catch(res => {
                      if (res) {
                        this.PresentHistory.unshift({
                          id: item.id,
                          idx: this.PresentHistory.length,
                          Subject: item.subject,
                          Type: item.committee_des,
                          date_start: item.date_start,
                          date_end: item.date_end,
                          Rm: item.Rm,
                          files: [],
                          objData: {
                            ...item,
                            Lecturer: null,
                            CustomDetail: ''
                          },
                          Train_Type: 'Custom',
                          Condi: false,
                          type_ms: '2',
                        })
                      }
                    })
                    break
                  default:
                    break
                }
              })
            }
            // console.log('---------------')
            // this.SortData = this.UniqueArraybyId(this.TrainHistory, 'Type')
            // console.log(this.SortData)
            // console.log('---------------')
          }).catch(res => {
            if (res) {
              this.HistoryExpertData.map(item => {
                switch (item.type) {
                  case '6':
                  case '13':
                  case '14':
                  case '23':
                  case '24':
                    this.initLecturerData({
                      Ref_id: item.Ref_id,
                      perid: params.perid
                    }).then(res => {
                      if (res) {
                        this.PresentHistory.unshift({
                          id: item.id,
                          idx: this.PresentHistory.length,
                          Subject: item.subject,
                          Type: item.committee_des,
                          date_start: item.date_start,
                          date_end: item.date_end,
                          Rm: item.Rm,
                          files: [],
                          objData: {
                            ...item,
                            Lecturer: this.LecturerData.length > 0 ? this.LecturerData[0] : null,
                            CustomDetail: this.LecturerData.length > 0 ? '<div>' +
                                '<div>โครงการ ' + this.LecturerData[0].Project_name + '</div>' +
                                '<div>ผู้เชิญ ' + this.LecturerData[0].Invite + ' จำนวน ' + this.LecturerData[0].Hour + ' ช.ม.  ช่วงที่เป็นวิทยากร ' + (this.LecturerData[0].DateStart == '0000-00-00' ? ' - ' : Vue.filter('DateToThai')(this.LecturerData[0].DateStart)) + ' - ' + (this.LecturerData[0].DateEnd == '0000-00-00' ? ' - ' : Vue.filter('DateToThai')(this.LecturerData[0].DateEnd)) + ' เวลา ' + this.LecturerData[0].TimeStart + ' น. - ' + this.LecturerData[0].TimeEnd + ' น.</div>' +
                                '<div>สถานที่ ' + this.LecturerData[0].Place + '</div>' +
                                '<div>เลขที่หนังสือ ' + this.LecturerData[0].DocNo + ' วันที่ออกหนัสือ ' + (this.LecturerData[0].DateDocNo == '0000-00-00' ? ' - ' : Vue.filter('DateToThai')(this.LecturerData[0].DateDocNo)) + '</div>' +
                                '</div>' : ''
                          },
                          Train_Type: 'Custom',
                          Condi: false,
                          type_ms: '2',
                        })
                      }
                    }).catch(res => {
                      if (res) {
                        this.PresentHistory.unshift({
                          id: item.id,
                          idx: this.PresentHistory.length,
                          Subject: item.subject,
                          Type: item.committee_des,
                          date_start: item.date_start,
                          date_end: item.date_end,
                          Rm: item.Rm,
                          files: [],
                          objData: {
                            ...item,
                            Lecturer: null,
                            CustomDetail: ''
                          },
                          Train_Type: 'Custom',
                          Condi: false,
                          type_ms: '2',
                        })
                      }
                    })
                    break
                  default:
                    break
                }
              })
            }
          })

          this.initJournalProject({
            perid: params.perid
          }).then(res => {
            if (res) {
              if (this.JournalData.length > 0) {
                this.JournalHistory = this.JournalData
              }
            }
          })

          this.initAwardProject({
            perid: params.perid
          }).then(res => {
            if (res) {
              if (this.AwardData.length > 0) {
                this.AwardHistory = this.AwardData
              }
            }
          })
        }
      }).catch(res => {
        if (res) {
          this.initCommitHistory({
            perid: params.perid
          }).then(res => {
            if (res) {
              if (this.CommitData.length > 0) {
                this.CommitData.map(item => {
                  this.CommitHistory.unshift({
                    id: '',
                    idx: this.CommitHistory.length,
                    Subject: item.Detail,
                    Type: 'กรรมการ',
                    date_start: item.BegDate,
                    date_end: item.EndDate,
                    Rm: item.DocNo,
                    files: [],
                    objData: item,
                    Train_Type: 'Commit',
                    Condi: false,
                    type_ms: '1'
                  })
                })
              }
            }
          })

          this.initPresentHistory({
            perid: params.perid
          }).then(res => {
            if (res) {
              if (this.PresentData.length > 0) {
                this.PresentData.map(item => {
                  this.PresentHistory.unshift({
                    id: '',
                    idx: this.PresentHistory.length,
                    Subject: item.Topic,
                    Type: item.PresentAction,
                    date_start: item.BegDate,
                    date_end: item.EndDate,
                    Rm: ': ' + item.Detail + ' สถานที่ ' + item.Place + ' ผู้จัด ' + item.Holder,
                    files: [],
                    objData: item,
                    Train_Type: 'Present',
                    Condi: false,
                    type_ms: '2'
                  })
                })
              }
            }
          })

          this.initJournalProject({
            perid: params.perid
          }).then(res => {
            if (res) {
              if (this.JournalData.length > 0) {
                this.JournalHistory = this.JournalData
              }
            }
          })

          this.initAwardProject({
            perid: params.perid
          }).then(res => {
            if (res) {
              if (this.AwardData.length > 0) {
                this.AwardHistory = this.AwardData
              }
            }
          })
        }
        // console.log('---------------')
        // this.SortData = this.UniqueArraybyId(this.TrainHistory, 'Type')
        // console.log(this.SortData)
        // console.log('---------------')
      })

      this.dialog = true
    },
    ShowDetailData(param) {
      this.EditWorkGroupType = ''
      this.EditWorkGroupTypeSubject = ''
      this.EditWorkGroupProjectCode = ''
      this.EditWorkGroupProjectName = ''
      this.EditWorkGroupDateS = ''
      this.EditWorkGroupDateE = ''
      this.EditWorkTravelDateS = ''
      this.EditWorkTravelDateE = ''
      this.EdittimeSForLecturer = ''
      this.EdittimeEForLecturer = ''
      this.EditLecturerDateDocOut = ''
      this.EditLecturerDocNo = ''
      this.EditLecturerPlace = ''
      this.EditLecturerInvite = ''
      this.EditLecturerHour = ''
      this.EditLecturerProjectName = ''
      this.EditRm = ''
      this.ChkEditData = false
      this.CheckCordi = false
      this.dialogShowDetail = true
      this.FileToShow = []
      this.dumpCommitData = []
      this.ObjEditData = null

      this.ObjEditData = param
      this.ObjEditData.objData.Ref_id = ((this.ObjEditData.objData.Ref_id == null || this.ObjEditData.objData.Ref_id == '') ? this.getRandomFileName() : this.ObjEditData.objData.Ref_id)
      if (param.type_ms == '0') {
        this.dumpCommitData = this.CommittType.filter(item => item.Committee_code == '15' || item.Committee_code == '16'
            || item.Committee_code == '17' || item.Committee_code == '18')
      } else if (param.type_ms == '1') {
        this.dumpCommitData = this.CommittType.filter(item => item.Committee_code == '5' || item.Committee_code == '10'
            || item.Committee_code == '11' || item.Committee_code == '12' || item.Committee_code == '19')
      } else if (param.type_ms == '2') {
        this.dumpCommitData = this.CommittType.filter(item => item.Committee_code == '6' || item.Committee_code == '13'
            || item.Committee_code == '14' || item.Committee_code == '23' || item.Committee_code == '24')
      } else {
        this.dumpCommitData = this.CommittType
      }
      if (param.Train_Type == 'Custom') {
        this.EditWorkGroupType = param.objData.Committee_code
        this.EditWorkGroupTypeSubject = param.objData.subject
        this.EditWorkGroupProjectCode = param.objData.Project_code
        this.EditWorkGroupDateS = (param.objData.date_start == '0000-00-00' ? '' : param.objData.date_start)
        this.EditWorkGroupDateE = (param.objData.date_end == '0000-00-00' ? '' : param.objData.date_end)
        this.EditWorkTravelDateS = (param.objData.date_travel_start == '0000-00-00' ? '' : param.objData.date_travel_start)
        this.EditWorkTravelDateE = (param.objData.date_travel_start == '0000-00-00' ? '' : param.objData.date_travel_end)
        this.EdittimeSForLecturer = param.objData.time_start
        this.EdittimeEForLecturer = param.objData.time_end
        this.EditLecturerDateDocOut = param.objData.Lecturer != null ? (param.objData.Lecturer.DateDocNo == '0000-00-00' ? '' : param.objData.Lecturer.DateDocNo) : ''
        this.EditLecturerDocNo = param.objData.Lecturer != null ? param.objData.Lecturer.DocNo : ''
        this.EditLecturerPlace = param.objData.Lecturer != null ? param.objData.Lecturer.Place : ''
        this.EditLecturerInvite = param.objData.Lecturer != null ? param.objData.Lecturer.Invite : ''
        this.EditLecturerHour = param.objData.Lecturer != null ? param.objData.Lecturer.Hour : ''
        this.EditLecturerDateStart = param.objData.Lecturer != null ? (param.objData.Lecturer.DateStart == '0000-00-00' ? '' : param.objData.Lecturer.DateStart) : ''
        this.EditLecturerTimeStart = param.objData.Lecturer != null ? param.objData.Lecturer.TimeStart : ''
        this.EditLecturerDateEnd = param.objData.Lecturer != null ? (param.objData.Lecturer.DateEnd == '0000-00-00' ? '' : param.objData.Lecturer.DateEnd) : ''
        this.EditLecturerTimeEnd = param.objData.Lecturer != null ? param.objData.Lecturer.TimeEnd : ''
        this.EditLecturerProjectName = param.objData.Lecturer != null ? param.objData.Lecturer.Project_name : ''
        this.EditRm = param.objData.Rm
        this.CheckCordi = param.Condi
        if (this.EditWorkGroupProjectCode) {
          this.CheckProject2()
        }
        this.initTrainFilesProject({
          Ref_id: param.objData.Ref_id
        }).then(res => {
          if (res) {
            this.FileToShow = this.TrainFilesData
          }
        }).catch(resErr => {
          if (resErr) {
            this.FileToShow = []
          }
        })
      }
    },
    ShowDetailFile(param) {
      console.log(param)
    },
    AddWorkGuest() {
      // var CheckCoordi = false
      // if (this.TypeEdit == '0') {
      //   if (this.WorkGroupType != '' && this.WorkGroupTypeSubject != ''
      //       && this.WorkGroupDateS != '' && this.WorkGroupDateE != '') {
      //     CheckCoordi = false
      //   } else {
      //     CheckCoordi = true
      //   }
      // } else {
      //   if (this.WorkGroupType != '' && this.WorkGroupTypeSubject != ''
      //     && this.WorkGroupDateS != '' && this.WorkGroupDateE != ''
      //     && this.WorkTravelDateS != '' && this.WorkTravelDateE != ''
      //     && this.timeSForLecturer != '' && this.timeEForLecturer != '') {
      //     CheckCoordi = false
      //   } else {
      //     CheckCoordi = true
      //   }
      // }

      if (this.WorkGroupType != '' && this.WorkGroupTypeSubject != ''
          && this.WorkGroupDateS != '') {
        if (this.WorkGroupType == '6' || this.WorkGroupType == '13' || this.WorkGroupType == '14' || this.WorkGroupType == '23' || this.WorkGroupType == '24') {
          if (this.LecturerProjectName != '' && this.LecturerHour != '' && this.LecturerInvite != '' && this.LecturerPlace != '' && this.LecturerDocNo != '' && this.LecturerDateDocOut != ''
              && this.LecturerDateStart != '' && this.LecturerTimeStart != '' && this.LecturerDateEnd != '' && this.LecturerTimeEnd != '') {
            this.WorkGroup.push({
              id: this.WorkGroup.length,
              perid: this.staff_sel.perid,
              full_Name: this.staff_sel.full_Name,
              subject: this.WorkGroupTypeSubject,
              date_start: this.WorkGroupDateS,
              date_end: this.WorkGroupDateE,
              date_travel_start: this.WorkTravelDateS,
              date_travel_end: this.WorkTravelDateE,
              time_start: this.timeSForLecturer,
              time_end: this.timeEForLecturer,
              Project_code: this.WorkGroupProjectCode,
              Project_name: this.WorkGroupProjectName,
              type: this.WorkGroupType,
              type_name: this.CommittType.filter(item => item.Committee_code == this.WorkGroupType)[0].committee_des,
              files: this.FileProject,
              Rm: this.Rm,
              JoinPerson: this.JoinPerson,
              Ref_id: this.getRandomFileName(),
              Lecturer: (this.WorkGroupType == '6' || this.WorkGroupType == '13' || this.WorkGroupType == '14' || this.WorkGroupType == '23' || this.WorkGroupType == '24') ? {
                Project_name: this.LecturerProjectName,
                Hour: this.LecturerHour,
                Invite: this.LecturerInvite,
                Place: this.LecturerPlace,
                DocNo: this.LecturerDocNo,
                DateDocNo: this.LecturerDateDocOut,
                DateStart: this.LecturerDateStart,
                TimeStart: this.LecturerTimeStart,
                DateEnd: this.LecturerDateEnd,
                TimeEnd: this.LecturerTimeEnd,
              } : null
            })

            this.WorkGroupProjectName = ''
            this.WorkGroupType = ''
            this.WorkGroupProjectCode = ''
            this.WorkGroupTypeSubject = ''
            this.WorkGroupDateS = ''
            this.WorkGroupDateE = ''
            this.WorkTravelDateS = ''
            this.WorkTravelDateE = ''
            this.timeSForLecturer = ''
            this.timeEForLecturer = ''
            this.LecturerProjectName = ''
            this.LecturerHour = ''
            this.LecturerInvite = ''
            this.LecturerPlace = ''
            this.LecturerDocNo = ''
            this.LecturerDateDocOut = ''
            this.LecturerDateStart = ''
            this.LecturerTimeStart = ''
            this.LecturerDateEnd = ''
            this.LecturerTimeEnd = ''
            this.FileProject = []
            this.files = []
            this.JoinPerson = []
            this.Rm = ''
            // if (this.TypeEdit == '0') {
            var staff = this.staffData.filter(item => item.perid == this.staff_sel.perid)
            if (staff.length > 0) {
              this.JoinPerson.push(staff[0])
            }
            // }
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'กรุณาระบุข้อมูลตามช่องสีแดงให้ครบถ้วน'
            })
          }
        } else {
          this.WorkGroup.push({
            id: this.WorkGroup.length,
            perid: this.staff_sel.perid,
            full_Name: this.staff_sel.full_Name,
            subject: this.WorkGroupTypeSubject,
            date_start: this.WorkGroupDateS,
            date_end: this.WorkGroupDateE,
            date_travel_start: this.WorkTravelDateS,
            date_travel_end: this.WorkTravelDateE,
            time_start: this.timeSForLecturer,
            time_end: this.timeEForLecturer,
            Project_code: this.WorkGroupProjectCode,
            Project_name: this.WorkGroupProjectName,
            type: this.WorkGroupType,
            type_name: this.CommittType.filter(item => item.Committee_code == this.WorkGroupType)[0].committee_des,
            files: this.FileProject,
            Rm: this.Rm,
            JoinPerson: this.JoinPerson,
            Ref_id: this.getRandomFileName(),
            Lecturer: (this.WorkGroupType == '6' || this.WorkGroupType == '13' || this.WorkGroupType == '14' || this.WorkGroupType == '23' || this.WorkGroupType == '24') ? {
              Project_name: this.LecturerProjectName,
              Hour: this.LecturerHour,
              Invite: this.LecturerInvite,
              Place: this.LecturerPlace,
              DocNo: this.LecturerDocNo,
              DateDocNo: this.LecturerDateDocOut,
              DateStart: this.LecturerDateStart,
              TimeStart: this.LecturerTimeStart,
              DateEnd: this.LecturerDateEnd,
              TimeEnd: this.LecturerTimeEnd,
            } : null
          })

          this.WorkGroupProjectName = ''
          this.WorkGroupType = ''
          this.WorkGroupProjectCode = ''
          this.WorkGroupTypeSubject = ''
          this.WorkGroupDateS = ''
          this.WorkGroupDateE = ''
          this.WorkTravelDateS = ''
          this.WorkTravelDateE = ''
          this.timeSForLecturer = ''
          this.timeEForLecturer = ''
          this.LecturerProjectName = ''
          this.LecturerHour = ''
          this.LecturerInvite = ''
          this.LecturerPlace = ''
          this.LecturerDocNo = ''
          this.LecturerDateDocOut = ''
          this.LecturerDateStart = ''
          this.LecturerTimeStart = ''
          this.LecturerDateEnd = ''
          this.LecturerTimeEnd = ''
          this.FileProject = []
          this.files = []
          this.JoinPerson = []
          this.Rm = ''
          // if (this.TypeEdit == '0') {
          /**/
          staff = this.staffData.filter(item => item.perid == this.staff_sel.perid)
          if (staff.length > 0) {
            this.JoinPerson.push(staff[0])
          }
          // }
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุข้อมูลตามช่องสีแดงให้ครบถ้วน'
        })
      }
    }
  },
  mounted() {
    this.changeColor({
      color: ConstData.defaultColorApp
    })
    this.changeHeaderName({
      headerName: ConstData.defaultHeaderApp
    })
    this.changeTypeProject({
      type: null
    })
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '12'
        })
        this.getMenuPermissData().then(res => {
          if (res) {
            if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '12' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
              this.maintain = false
              this.getPermissionData({
                perid: this.MeData[0].perid
              }).then(res => {
                if (res) {
                  this.PermissionAdmin.map((Per_i, idx) => {
                    if (Per_i.permission_id == '8000') {
                      this.CheckAdmin = true
                      this.getPermissionDep({
                        perid: this.MeData[0].perid
                      }).then(res => {
                        if (res) {
                          this.initDepartData().then(res => {
                            if (res) {
                              this.Permission_Dep.map(Dep_i => {
                                this.depart.map(depart_i => {
                                  if (Dep_i.dep_id == depart_i.dep_id) {
                                    this.DepartData.push(depart_i)
                                  }
                                })
                              })
                              this.init()
                            }
                          })
                        } else {
                          this.$swal.fire({
                            icon: 'error',
                            title: 'พบข้อผิดพลาด กรุณารีเฟรชหน้าเว็บไซต์ใหม่อีกครั้ง ถ้ายังไม่หายโปรดติดต่อผู้ดูแลระบบ'
                          })
                        }
                      })
                    } else {
                      if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                        this.$router.push('/')
                      }
                    }
                  })
                } else {
                  this.getPermissionUserData({
                    perid: this.MeData[0].perid
                  }).then(res => {
                    if (res) {
                      this.Permission.map((Per_i, idx) => {
                        if (Per_i.permission_id == '8000') {
                          this.CheckAdmin = true
                          this.getPermissionDepUserData({
                            perid: this.MeData[0].perid
                          }).then(res => {
                            if (res) {
                              this.initDepartData().then(res => {
                                if (res) {
                                  this.Permission_Dep_User.map(Dep_i => {
                                    this.depart.map(depart_i => {
                                      if (Dep_i.dep_id == depart_i.dep_id) {
                                        this.DepartData.push(depart_i)
                                      }
                                    })
                                  })
                                  this.init()
                                }
                              })
                            } else {
                              this.$swal.fire({
                                icon: 'error',
                                title: 'พบข้อผิดพลาด กรุณารีเฟรชหน้าเว็บไซต์ใหม่อีกครั้ง ถ้ายังไม่หายโปรดติดต่อผู้ดูแลระบบ'
                              })
                            }
                          })
                        } else {
                          if (!this.CheckAdmin && idx == this.Permission.length - 1) {
                            this.$router.push('/')
                          }
                        }
                      })
                    } else {
                      this.$router.push('/')
                    }
                  })
                }
              })
            } else {
              this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '12' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '12')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
              this.maintain = true
              this.dialogLoading = false
            }
          }
        }).then(err => {
          if (err) {
            this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '12' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '12')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
            this.maintain = true
            this.dialogLoading = false
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}
</style>
